/**
 * Lucky Inger Order Form — li-order-form.js
 * Upload to Shopify Assets. Loaded once via theme.liquid.
 *
 * Per-product configuration via product metafield:
 *   Namespace: custom  Key: order_form_config  Type: JSON
 *
 * Config JSON structure (all fields optional — sensible defaults apply):
 * {
 *   "form_type":        "dtf",          // dtf | screenprint | fishing-shirt | footy-shorts | coolers | caps | accessories
 *   "show_adult_tee":   true,
 *   "show_kids_tee":    true,
 *   "show_adult_hood":  true,
 *   "show_kids_hood":   false,
 *   "show_adult_sweat": false,
 *   "show_kids_sweat":  false,
 *   "show_bagging":     false,
 *   "bagging_rate":     1.70,
 *   "show_setup_fee":   false,          // screenprint only
 *   "setup_fee":        990.00,         // screenprint only
 *   "show_colour_surcharge": false,     // screenprint only
 *   "colour_surcharge": 99.00,          // screenprint only
 *   "minimum_order":    25,
 *
 *   // Garment info bars — set per product, shown above size grid
 *   "atee_info":        "AS Colour Staple — 180GSM",
 *   "ahood_info":       "AS Colour Relax Hood — 320GSM",
 *   "ktee_info":        "AS Colour Staple Kids — 180GSM",
 *   "khood_info":       "AS Colour Supply Hood — 290GSM",
 *   "asweat_info":      "AS Colour Supply Crew — 310GSM",
 *   "ksweat_info":      "AS Colour Supply Crew Kids — 310GSM",
 *   "afs_info":         "Fishing Shirt",
 *   "kfs_info":         "Kids Fishing Shirt",
 *   "ashort_info":      "Footy Shorts",
 *   "kshort_info":      "Kids Footy Shorts",
 *
 *   // Colour size cap — per garment type, per product
 *   // cap values: "3XL" | "4XL" | "5XL" | "none"
 *   // full_range_colours: comma-separated colours that bypass the cap (black always bypasses)
 *   "atee_colour_cap":            "3XL",
 *   "atee_full_range_colours":    "black",
 *   "ahood_colour_cap":           "3XL",
 *   "ahood_full_range_colours":   "black",
 *   "asweat_colour_cap":          "3XL",
 *   "asweat_full_range_colours":  "black",
 *
 *   "tier1_min": 25,  "tier1_atee": 29.90, "tier1_ahood": 54.90, "tier1_ktee": 29.90, "tier1_khood": 54.90,
 *   "tier2_min": 50,  "tier2_atee": 27.00, "tier2_ahood": 49.40, "tier2_ktee": 27.00, "tier2_khood": 49.40,
 *   "tier3_min": 100, "tier3_atee": 25.40, "tier3_ahood": 46.65, "tier3_ktee": 25.40, "tier3_khood": 46.65,
 *   "tier4_min": 200, "tier4_atee": 23.90, "tier4_ahood": 43.90, "tier4_ktee": 23.90, "tier4_khood": 43.90,
 *   "tier5_min": 0,   "tier5_atee": 0,     "tier5_ahood": 0                            (optional 5th tier)
 * }
 */

(function () {
  'use strict';

  // ── Colour swatch helper ──────────────────────────────────────────────────
  // Returns a CSS colour value for a colour name.
  // Priority: 1) hex from Shopify swatch metafield (passed via colourHexMap)
  //           2) CSS named colour (black, navy, white etc work natively)
  //           3) tiny fallback map for known non-CSS names
  // No hardcoded full bank — new colours set in Shopify admin appear automatically.
  var COLOUR_FALLBACKS = {
    'grey marle': '#aaaaaa',
    'grey-marle': '#aaaaaa',
    'hot pink':   '#e91e8c',
    'kelly green':'#4caf50',
    'bottle green':'#1a4a2e',
    'dusty pink': '#d4a5a0',
    'pea green':  '#6b8e23',
    'sky blue':   '#87ceeb',
    'cobalt':     '#0047ab',
    'sapphire':   '#1e56a0',
    'ecru':       '#f0e8d0',
    'army':       '#4a5c3a',
    'walnut':     '#7a5230',
    'forest':     '#2d5a3d',
    'cypress':    '#5c7a4a',
    'sand':       '#c9a96e',
    'bone':       '#e8dcc8',
    'lavender':   '#b89fd4',
    'tan':        '#c8a882',
    'maroon':     '#7b2d2d',
    'royal':      '#2754a6',
    'sage':       '#8faf72',
  };

  function getSwatchColour(colourName, colourHexMap) {
    // 1. From Shopify swatch metafield
    if (colourHexMap && colourHexMap[colourName]) return colourHexMap[colourName];
    // 2. Fallback map for known non-CSS names
    var lower = (colourName || '').toLowerCase().trim();
    if (COLOUR_FALLBACKS[lower]) return COLOUR_FALLBACKS[lower];
    // 3. Use the name directly as CSS — works for Black, White, Navy, Red, Green etc
    return lower;
  }

  // ── Default pricing (overridden by product metafield config) ─────────────
  var DEFAULT_CONFIG = {
    form_type: 'dtf',
    show_adult_tee:  true,
    show_kids_tee:   false,
    show_adult_hood: false,
    show_kids_hood:  false,
    show_adult_sweat: false,
    show_kids_sweat:  false,
    show_bagging: false,
    bagging_rate: 1.70,
    show_setup_fee: false,
    setup_fee: 990.00,
    show_colour_surcharge: false,
    colour_surcharge: 99.00,
    minimum_order: 25,
    // Garment info bars — set per product via admin extension, no hardcoded defaults
    atee_info:   '',
    ahood_info:  '',
    ktee_info:   '',
    khood_info:  '',
    asweat_info: '',
    ksweat_info: '',
    afs_info:    '',
    kfs_info:    '',
    ashort_info: '',
    kshort_info: '',
    // Colour size cap — per garment, per product
    // cap: "3XL" | "4XL" | "5XL" | "none"  — black always bypasses
    atee_colour_cap:           '3XL',
    atee_full_range_colours:   'black',
    ahood_colour_cap:          '3XL',
    ahood_full_range_colours:  'black',
    asweat_colour_cap:         '3XL',
    asweat_full_range_colours: 'black',
    // DTF tiers
    tier1_min: 25,  tier1_atee: 29.90, tier1_ahood: 54.90, tier1_ktee: 29.90, tier1_khood: 54.90, tier1_asweat: 49.90, tier1_ksweat: 39.90,
    tier2_min: 50,  tier2_atee: 27.00, tier2_ahood: 49.40, tier2_ktee: 27.00, tier2_khood: 49.40, tier2_asweat: 46.00, tier2_ksweat: 37.00,
    tier3_min: 100, tier3_atee: 25.40, tier3_ahood: 46.65, tier3_ktee: 25.40, tier3_khood: 46.65, tier3_asweat: 43.00, tier3_ksweat: 34.50,
    tier4_min: 200, tier4_atee: 23.90, tier4_ahood: 43.90, tier4_ktee: 23.90, tier4_khood: 43.90, tier4_asweat: 40.50, tier4_ksweat: 32.50,
    tier5_min: 0,   tier5_atee: 0,     tier5_ahood: 0,     tier5_ktee: 0,     tier5_khood: 0,     tier5_asweat: 0,     tier5_ksweat: 0,
    // Fishing shirt tiers
    tier1_min_fs: 25,  tier1_afs: 44.90, tier1_kfs: 44.90,
    tier2_min_fs: 51,  tier2_afs: 34.90, tier2_kfs: 34.90,
    tier3_min_fs: 101, tier3_afs: 33.50, tier3_kfs: 33.50,
    tier4_min_fs: 200, tier4_afs: 29.90, tier4_kfs: 29.90,
    // Footy shorts tiers (adult/kids separate — kids tier 4 uses 8% reduction)
    tier1_min_sh: 26,  tier1_ashort: 29.90, tier1_kshort: 23.90,
    tier2_min_sh: 51,  tier2_ashort: 27.90, tier2_kshort: 22.90,
    tier3_min_sh: 101, tier3_ashort: 24.90, tier3_kshort: 22.90,
    tier4_min_sh: 200, tier4_ashort: 22.90, tier4_kshort: 21.10,
    // Screenprint tiers (tees + hoods only)
    tier1_sp_min: 51,  tier1_sp_atee: 35.75, tier1_sp_ahood: 61.40, tier1_sp_ktee: 35.75, tier1_sp_khood: 61.40,
    tier2_sp_min: 126, tier2_sp_atee: 31.65, tier2_sp_ahood: 58.45, tier2_sp_ktee: 31.65, tier2_sp_khood: 58.45,
    tier3_sp_min: 251, tier3_sp_atee: 25.25, tier3_sp_ahood: 54.35, tier3_sp_ktee: 25.25, tier3_sp_khood: 54.35,
    tier4_sp_min: 501, tier4_sp_atee: 19.50, tier4_sp_ahood: 51.15, tier4_sp_ktee: 19.50, tier4_sp_khood: 51.15,
    // Hood style surcharge
    full_zip_surcharge: 7.70,
    // Oversize tee surcharges (DTF adult tees only, 4XL+)
    oversize_4xl: 1.65,
    oversize_5xl: 1.65,
    oversize_6xl: 4.10,
    oversize_7xl: 4.10,
    oversize_8xl: 4.10,
    oversize_9xl: 6.25,
    oversize_10xl: 6.25,
    oversize_11xl: 6.25,
  };

  // ── Size definitions ──────────────────────────────────────────────────────
  var SIZES = {
    atee:   ['XS','S','M','L','XL','2XL','3XL','4XL','5XL','6/7XL','8/9XL','10/11XL'],
    ktee:   ['K2','K4','K6','K8','K10','K12','K14','K16'],
    ahood:  ['XS','S','M','L','XL','2XL','3XL','4XL','5XL','6/7XL','8/9XL','10/11XL'],
    khood:  ['K2','K4','K6','K8','K10','K12','K14','K16'],
    asweat: ['XS','S','M','L','XL','2XL','3XL','4XL','5XL','6/7XL','8/9XL','10/11XL'],
    ksweat: ['K2','K4','K6','K8','K10','K12','K14','K16'],
    afs:    ['XS','S','M','L','XL','2XL','3XL','4XL','5XL'],
    kfs:    ['K2','K4','K6','K8','K10','K12','K14','K16'],
    ashort: ['6','8','10','12','14','S','M','L','XL','2XL','3XL'],
    kshort: ['K4','K6','K8','K10','K12'],
  };

  // Oversize sizes — used for cap checking
  var OVERSIZE_SIZES = ['4XL','5XL','6/7XL','8/9XL','10/11XL'];

  // ── Colour cap helper ─────────────────────────────────────────────────────
  // Returns true if this size should be hidden for the given garment + colour.
  // Black always bypasses. Additional full-range colours set per product in config.
  // cap values: "3XL" (hides 4XL+) | "4XL" (hides 5XL+) | "5XL" (hides 6/7XL+) | "none"
  var CAP_SIZES = {
    '3XL': ['4XL','5XL','6/7XL','8/9XL','10/11XL'],
    '4XL': ['5XL','6/7XL','8/9XL','10/11XL'],
    '5XL': ['6/7XL','8/9XL','10/11XL'],
    'none': [],
  };

  function isColourCapped(cfg, garmentKey, colour, size) {
    if (!colour) return false;
    var capKey = garmentKey + '_colour_cap';
    var cap = cfg[capKey] || '3XL';
    if (cap === 'none') return false;
    var fullRangeKey = garmentKey + '_full_range_colours';
    var fullRange = (cfg[fullRangeKey] || 'black').toLowerCase();
    var fullRangeList = fullRange.split(',').map(function(s) { return s.trim(); });
    // Black always full range + any additional colours set in config
    if (fullRangeList.indexOf(colour.toLowerCase()) >= 0) return false;
    var cappedList = CAP_SIZES[cap] || CAP_SIZES['3XL'];
    return cappedList.indexOf(size) >= 0;
  }

  function getCapWarning(cfg, garmentKey, colour) {
    if (!colour) return '';
    var capKey = garmentKey + '_colour_cap';
    var cap = cfg[capKey] || '3XL';
    if (cap === 'none') return '';
    var fullRangeKey = garmentKey + '_full_range_colours';
    var fullRange = (cfg[fullRangeKey] || 'black').toLowerCase();
    var fullRangeList = fullRange.split(',').map(function(s) { return s.trim(); });
    if (fullRangeList.indexOf(colour.toLowerCase()) >= 0) return '';
    return '&#9888; ' + colour + ' available XS to ' + cap + ' only. Larger sizes are hidden.';
  }

  // ── Helpers ───────────────────────────────────────────────────────────────
  function fmt(n) { return '$' + Number(n || 0).toFixed(2); }
  function el(id) { return document.getElementById(id); }
  function uid() { return Math.random().toString(36).slice(2, 9); }

  function getTiers(cfg, prefix) {
    // Build tier array from config for a given prefix e.g. 'atee', 'sp_atee', 'afs', 'ashort'
    // Min key patterns:
    //   DTF/sweat: tier{n}_min
    //   Screenprint: tier{n}_sp_min
    //   Fishing shirts: tier{n}_min_fs
    //   Footy shorts: tier{n}_min_sh
    var tiers = [];
    var isSP    = prefix.indexOf('sp_')  === 0;
    var isFS    = prefix === 'afs' || prefix === 'kfs';
    var isSH    = prefix === 'ashort' || prefix === 'kshort';
    for (var i = 1; i <= 5; i++) {
      var min;
      if (isSP)   { min = parseInt(cfg['tier' + i + '_sp_min'],  10) || 0; }
      else if (isFS) { min = parseInt(cfg['tier' + i + '_min_fs'], 10) || 0; }
      else if (isSH) { min = parseInt(cfg['tier' + i + '_min_sh'], 10) || 0; }
      else           { min = parseInt(cfg['tier' + i + '_min'],    10) || 0; }
      var price = parseFloat(cfg['tier' + i + '_' + prefix]) || 0;
      if (min > 0 && price > 0) tiers.push({ min: min, price: price });
    }
    return tiers.sort(function(a, b) { return b.min - a.min; }); // highest min first
  }

  function getTierPrice(tiers, units) {
    for (var i = 0; i < tiers.length; i++) {
      if (units >= tiers[i].min) return tiers[i].price;
    }
    return tiers.length ? tiers[tiers.length - 1].price : 0;
  }

  function getTierLabel(tiers, units) {
    for (var i = 0; i < tiers.length; i++) {
      if (units >= tiers[i].min) {
        var next = i > 0 ? tiers[i - 1] : null;
        return next ? tiers[i].min + '\u2013' + (next.min - 1) + ' units' : tiers[i].min + '+ units';
      }
    }
    return 'Below minimum';
  }

  function getOversizeSurcharge(cfg, size) {
    var s = (size || '').toLowerCase().replace('/', '');
    if (s === '4xl') return cfg.oversize_4xl || 0;
    if (s === '5xl') return cfg.oversize_5xl || 0;
    if (s === '67xl') return cfg.oversize_6xl || 0;
    if (s === '89xl') return cfg.oversize_8xl || 0;
    if (s === '1011xl') return cfg.oversize_10xl || 0;
    return 0;
  }

  // ── State ─────────────────────────────────────────────────────────────────
  var orderLines = [];
  var lineIdCounter = 0;

  function totalUnits() { return orderLines.reduce(function(s, l) { return s + (l.units || 0); }, 0); }
  function grandTotal() { return orderLines.reduce(function(s, l) { return s + (l.lineTotal || 0); }, 0); }

  // ── CSS ───────────────────────────────────────────────────────────────────
  var CSS = `
    /* ── Reset & base ─────────────────────────────────────────────────────── */
    .lif-root { font-family: inherit; color: #fff; }
    .lif-root *, .lif-root *::before, .lif-root *::after { box-sizing: border-box; }

    /* ── Layout ────────────────────────────────────────────────────────────── */
    .lif-wrap { display: grid; grid-template-columns: 280px 1fr; gap: 28px; min-height: 500px; align-items: start; }
    @media (max-width: 900px) { .lif-wrap { grid-template-columns: 1fr; } }

    /* ── Left panel ─────────────────────────────────────────────────────────  */
    .lif-left { position: sticky; top: 20px; padding-right: 0; }
    .lif-preview { width: 100%; aspect-ratio: 1/1; background: #1a1a1a; border: 1px solid #333; border-radius: 8px; overflow: hidden; display: flex; align-items: center; justify-content: center; }
    .lif-preview img { width: 100%; height: 100%; object-fit: contain; display: block; }
    .lif-preview-placeholder { color: #555; font-size: 13px; text-align: center; padding: 16px; }

    .lif-order-lines-box { background: #111; border: 1px solid #333; border-radius: 8px; padding: 16px; }
    .lif-order-lines-title { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.1em; color: #888; margin-bottom: 12px; }
    .lif-order-empty { color: #555; font-size: 13px; font-style: italic; }

    /* Order lines — scrollable when many lines added */
    #lif-order-lines { max-height: 320px; overflow-y: auto; overflow-x: hidden; }
    #lif-order-lines::-webkit-scrollbar { width: 4px; }
    #lif-order-lines::-webkit-scrollbar-track { background: #1a1a1a; }
    #lif-order-lines::-webkit-scrollbar-thumb { background: #444; border-radius: 2px; }

    .lif-order-line { border-bottom: 1px solid #222; padding: 10px 0; }
    .lif-order-line:last-child { border-bottom: none; }
    .lif-order-line-header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 4px; }
    .lif-order-line-label { font-size: 12px; font-weight: 600; color: #ccc; flex: 1; margin-right: 8px; }
    .lif-order-line-remove { background: none; border: none; color: #555; cursor: pointer; font-size: 16px; padding: 0; line-height: 1; flex-shrink: 0; }
    .lif-order-line-remove:hover { color: #e74c3c; }
    .lif-order-line-detail { font-size: 11px; color: #666; line-height: 1.6; margin-bottom: 4px; }
    .lif-order-line-sizes { display: flex; flex-wrap: wrap; gap: 4px; margin: 4px 0; }
    .lif-order-line-size { background: #222; border-radius: 3px; padding: 2px 6px; font-size: 10px; color: #aaa; white-space: nowrap; }
    .lif-order-line-total { font-size: 13px; font-weight: 700; color: #ccc; text-align: right; margin-top: 6px; padding-top: 6px; border-top: 1px solid #1a1a1a; }

    .lif-summary-rows { margin-top: 12px; padding-top: 12px; border-top: 1px solid #333; }
    .lif-summary-row { display: flex; justify-content: space-between; font-size: 12px; color: #888; padding: 3px 0; }
    .lif-summary-row.total { font-size: 14px; font-weight: 700; color: #fff; padding-top: 10px; margin-top: 6px; border-top: 1px solid #444; }

    .lif-stored-banner { background: #1a2a1a; border: 1px solid #2d4a2d; border-radius: 6px; padding: 8px 12px; font-size: 12px; color: #6aaa6a; margin-top: 12px; display: none; }
    .lif-stored-banner.visible { display: block; }

    /* ── Gallery ─────────────────────────────────────────────────────────── */
    .lif-preview-wrap { display:flex; gap:8px; margin-bottom:16px; }
    .lif-preview-wrap .lif-preview { flex:1; margin-bottom:0; }
    .lif-gallery-thumbs { display:flex; flex-direction:column; gap:5px; width:48px; flex-shrink:0; }
    .lif-gallery-thumbs:empty { display:none; width:0; }
    .lif-gallery-thumb { width:48px; height:48px; border:2px solid rgba(255,255,255,0.12); border-radius:5px; overflow:hidden; cursor:pointer; padding:0; background:transparent; transition:border-color 0.15s; flex-shrink:0; }
    .lif-gallery-thumb img { width:100%; height:100%; object-fit:cover; display:block; }
    .lif-gallery-thumb.active, .lif-gallery-thumb:hover { border-color:#8b7355; }

    .lif-submit-btn { width: 100%; padding: 14px; margin-top: 16px; background: #8b7355; color: #fff; border: none; border-radius: 6px; font-size: 13px; font-weight: 700; cursor: not-allowed; text-transform: uppercase; letter-spacing: 0.08em; opacity: 0.45; transition: background 0.2s, opacity 0.2s; }
    .lif-submit-btn.enabled { opacity: 1; cursor: pointer; pointer-events: all; }
    .lif-submit-btn.enabled:hover { background: #7a6348; }

    .lif-view-order-btn { display: none; width: 100%; padding: 10px; margin-top: 8px; text-align: center; font-size: 12px; color: #888; text-decoration: none; border: 1px solid #333; border-radius: 6px; }
    .lif-view-order-btn:hover { border-color: #555; color: #ccc; }
    .lif-view-order-btn.visible { display: block; }

    /* ── Right panel ────────────────────────────────────────────────────────  */
    .lif-right { min-width: 0; }

    /* ── Setup fee card ──────────────────────────────────────────────────── */
    .lif-setup-card { background: #111; border: 1px solid #333; border-radius: 8px; padding: 16px; margin-bottom: 20px; }
    .lif-setup-question { font-size: 14px; font-weight: 600; color: #ccc; margin-bottom: 4px; }
    .lif-setup-sub { font-size: 12px; color: #666; margin-bottom: 12px; line-height: 1.5; }
    .lif-setup-btns { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
    .lif-setup-btn { padding: 10px; border: 1px solid #444; border-radius: 6px; background: #1a1a1a; color: #888; font-size: 12px; cursor: pointer; text-align: center; transition: all 0.15s; line-height: 1.4; }
    .lif-setup-btn:hover { border-color: #666; color: #ccc; }
    .lif-setup-btn.active { border-color: #8b7355; background: #2a1f10; color: #d4aa77; }

    /* ── Section label / step header ─────────────────────────────────────── */
    .lif-section-label { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.1em; color: #888; margin: 0 0 10px; }
    .lif-step { margin-bottom: 20px; }

    /* ── Design display (single design, not a dropdown) ──────────────────── */
    .lif-design-display { padding: 12px 16px; background: #111; border: 1px solid #333; border-radius: 6px; color: #ccc; font-size: 14px; font-weight: 500; }

    /* ── Design dropdown ─────────────────────────────────────────────────── */
    .lif-select-wrap { position: relative; }
    .lif-select-wrap::after { content: '▾'; position: absolute; right: 14px; top: 50%; transform: translateY(-50%); color: #888; pointer-events: none; font-size: 12px; }
    .lif-select { width: 100%; padding: 12px 36px 12px 16px; background: #111; border: 1px solid #333; border-radius: 6px; color: #fff; font-size: 14px; appearance: none; -webkit-appearance: none; cursor: pointer; transition: border-color 0.15s; }
    .lif-select:focus { outline: none; border-color: #8b7355; }
    .lif-select option { background: #1a1a1a; color: #fff; }

    /* ── Colour pills ────────────────────────────────────────────────────── */
    .lif-colour-card { background: #111; border: 1px solid #333; border-radius: 8px; padding: 16px; }
    .lif-colour-card-title { font-size: 13px; font-weight: 600; color: #ccc; margin-bottom: 4px; }
    .lif-colour-card-sub { font-size: 12px; color: #666; margin-bottom: 12px; line-height: 1.5; }
    .lif-colour-surcharge-badge { display: inline-flex; align-items: center; gap: 6px; background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.12); border-radius: 4px; padding: 4px 10px; font-size: 11px; color: #aaa; margin-bottom: 12px; }
    .lif-colour-pills { display: flex; flex-wrap: wrap; gap: 8px; }
    .lif-colour-pill { display: flex; align-items: center; gap: 8px; padding: 7px 32px 7px 12px; border: 1px solid #333; border-radius: 20px; background: #1a1a1a; color: #ccc; font-size: 13px; cursor: pointer; position: relative; transition: all 0.15s; white-space: nowrap; }
    .lif-colour-pill:hover { border-color: #555; color: #fff; }
    .lif-colour-pill.active { border-color: #8b7355; background: #2a1f10; color: #fff; padding-right: 32px; }
    .lif-colour-dot { width: 14px; height: 14px; border-radius: 50%; border: 1px solid rgba(255,255,255,0.25); flex-shrink: 0; display: block; }
    .lif-colour-check { display: none; position: absolute; right: 10px; top: 50%; transform: translateY(-50%); pointer-events: none; }
    .lif-colour-pill.active .lif-colour-check { display: flex; align-items: center; justify-content: center; }

    /* ── Garment card ────────────────────────────────────────────────────── */
    .lif-garment-card { background: #111; border: 1px solid #333; border-radius: 8px; padding: 16px; }
    .lif-garment-tabs { display: flex; gap: 6px; margin-bottom: 14px; flex-wrap: wrap; }
    .lif-garment-tab { padding: 7px 16px; border: 1px solid #333; border-radius: 4px; background: #1a1a1a; color: #888; font-size: 13px; cursor: pointer; transition: all 0.15s; }
    .lif-garment-tab:hover { border-color: #555; color: #ccc; }
    .lif-garment-tab.active { border-color: #ccc; background: #333; color: #fff; }
    .lif-garment-tab.hidden { display: none; }
    .lif-garment-info { font-size: 11px; color: #555; background: #161616; border-radius: 4px; padding: 6px 10px; margin-bottom: 12px; line-height: 1.5; }

    /* ── Hood / style pills ──────────────────────────────────────────────── */
    .lif-style-pills { display: flex; gap: 6px; margin-bottom: 14px; flex-wrap: wrap; }
    .lif-style-pill { padding: 6px 14px; border: 1px solid #333; border-radius: 4px; background: #1a1a1a; color: #888; font-size: 12px; cursor: pointer; transition: all 0.15s; }
    .lif-style-pill:hover { border-color: #555; color: #ccc; }
    .lif-style-pill.active { border-color: #ccc; background: #333; color: #fff; }

    /* ── Size rows ───────────────────────────────────────────────────────── */
    .lif-size-rows { display: flex; flex-direction: column; }
    .lif-size-row { display: flex; align-items: center; border-bottom: 1px solid #1a1a1a; padding: 7px 0; gap: 12px; }
    .lif-size-row:nth-child(even) { background: rgba(255,255,255,0.015); }
    .lif-size-row.hidden { display: none !important; }
    .lif-size-label { width: 64px; font-size: 13px; font-weight: 600; color: #ccc; flex-shrink: 0; }
    .lif-size-price { flex: 1; font-size: 12px; color: #555; }

    /* ── Stepper ─────────────────────────────────────────────────────────── */
    .lif-size-stepper { display: flex; align-items: center; }
    .lif-stepper-btn { width: 30px; height: 30px; border: 1px solid #333; background: #1a1a1a; color: #aaa; font-size: 16px; cursor: pointer; display: flex; align-items: center; justify-content: center; line-height: 1; transition: background 0.1s, color 0.1s; flex-shrink: 0; }
    .lif-stepper-btn:hover { background: #252525; color: #fff; }
    .lif-stepper-btn:first-child { border-radius: 4px 0 0 4px; }
    .lif-stepper-btn:last-child { border-radius: 0 4px 4px 0; }
    .lif-stepper-input { width: 44px; height: 30px; border: 1px solid #333; border-left: none; border-right: none; background: #111; color: #fff; font-size: 13px; text-align: center; padding: 0; -webkit-appearance: none; -moz-appearance: textfield; appearance: textfield; }
    .lif-stepper-input::-webkit-outer-spin-button,
    .lif-stepper-input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
    .lif-stepper-input:focus { outline: none; background: #1a1a1a; }

    /* ── Add combo button ────────────────────────────────────────────────── */
    .lif-add-combo-btn { width: 100%; padding: 13px; margin-top: 16px; background: transparent; border: 1px solid #c0392b; color: #c0392b; border-radius: 6px; font-size: 13px; font-weight: 500; cursor: pointer; transition: background 0.15s; letter-spacing: 0.02em; }
    .lif-add-combo-btn:hover { background: rgba(192,57,43,0.12); color: #e74c3c; }
    .lif-add-combo-btn:disabled { opacity: 0.35; cursor: not-allowed; }

    /* ── Fee row (bagging checkbox) ──────────────────────────────────────── */
    .lif-fee-row { display: flex; align-items: center; gap: 10px; padding: 10px 0; font-size: 13px; color: #888; border-bottom: 1px solid #1a1a1a; }
    .lif-fee-row input[type="checkbox"] { width: 16px; height: 16px; accent-color: #8b7355; cursor: pointer; flex-shrink: 0; }
    .lif-fee-row label { flex: 1; cursor: pointer; }
    .lif-fee-row .lif-fee-amount { color: #ccc; font-weight: 600; }

    /* ── Tier bar ────────────────────────────────────────────────────────── */
    .lif-tier-bar { display: flex; gap: 6px; flex-wrap: wrap; margin-top: 18px; }
    .lif-tier-card { flex: 1; min-width: 65px; border: 1px solid #2a2a2a; border-radius: 6px; padding: 8px 6px; text-align: center; background: #0e0e0e; transition: border-color 0.15s, background 0.15s; }
    .lif-tier-card.active { border-color: #8b7355; background: #2a1f10; }
    .lif-tier-min { font-size: 10px; color: #666; display: block; margin-bottom: 2px; text-transform: uppercase; letter-spacing: 0.05em; }
    .lif-tier-price { font-size: 14px; font-weight: 700; color: #999; display: block; }
    .lif-tier-card.active .lif-tier-min { color: #a08060; }
    .lif-tier-card.active .lif-tier-price { color: #d4aa77; }
    .lif-tier-msg { font-size: 12px; color: #555; text-align: center; margin-top: 10px; line-height: 1.4; }

    /* ── Error / success messages ────────────────────────────────────────── */
    .lif-msg { padding: 10px 14px; border-radius: 6px; font-size: 12px; margin-top: 12px; display: none; line-height: 1.5; }
    .lif-msg.error { display: block; background: rgba(192,57,43,0.15); border: 1px solid rgba(192,57,43,0.4); color: #e74c3c; }
    .lif-msg.success { display: block; background: rgba(39,174,96,0.1); border: 1px solid rgba(39,174,96,0.3); color: #2ecc71; }

    /* ── Cooler pack cards ───────────────────────────────────────────────── */
    .lif-pack-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
    .lif-pack-card { border: 1px solid #333; border-radius: 8px; padding: 16px 12px; background: #111; cursor: pointer; text-align: center; transition: all 0.15s; }
    .lif-pack-card:hover { border-color: #555; }
    .lif-pack-card.active { border-color: #8b7355; background: #2a1f10; }
    .lif-pack-qty { font-size: 13px; font-weight: 600; color: #888; display: block; margin-bottom: 4px; }
    .lif-pack-price { font-size: 20px; font-weight: 700; color: #fff; display: block; margin: 4px 0; }
    .lif-pack-unit { font-size: 11px; color: #666; display: block; }
    .lif-pack-card.active .lif-pack-qty { color: #a08060; }
    .lif-pack-card.active .lif-pack-price { color: #d4aa77; }

    /* ── Qty input (caps/accessories) ───────────────────────────────────── */
    .lif-qty-input { padding: 10px 14px; background: #111; border: 1px solid #333; border-radius: 6px; color: #fff; font-size: 14px; width: 140px; -webkit-appearance: none; -moz-appearance: textfield; appearance: textfield; transition: border-color 0.15s; }
    .lif-qty-input::-webkit-outer-spin-button,
    .lif-qty-input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
    .lif-qty-input:focus { outline: none; border-color: #8b7355; }

    /* ── Success state ───────────────────────────────────────────────────── */
    .lif-success { text-align: center; padding: 60px 20px; }
    .lif-success-icon { font-size: 48px; margin-bottom: 16px; color: #2ecc71; }
    .lif-success-title { font-size: 22px; font-weight: 700; color: #ccc; margin-bottom: 12px; }
    .lif-success-msg { font-size: 14px; color: #666; margin-bottom: 24px; line-height: 1.6; }
    .lif-success-link { display: inline-block; padding: 12px 24px; background: #8b7355; color: #fff; border-radius: 6px; text-decoration: none; font-weight: 600; transition: background 0.15s; }
    .lif-success-link:hover { background: #7a6348; }

    `;

  // ── LIOrder — defer to li-order-store.js if already loaded ─────────────────
  // li-order-store.js has the full implementation (badge, cart renderer, sessionStorage backup)
  // Only define a minimal fallback if it hasn't loaded yet
  if (!window.LIOrder) {
    window.LIOrder = (function() {
      var KEY = 'li_order_lines';
      function load() {
        try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch(e) { return []; }
      }
      function save(lines) {
        try { localStorage.setItem(KEY, JSON.stringify(lines)); } catch(e) {}
        window.dispatchEvent(new Event('li:order:updated'));
      }
      return {
        get:   function()      { return load(); },
        add:   function(line)  { var lines = load(); lines.push(line); save(lines); },
        remove:function(id)    { save(load().filter(function(l) { return l.id !== id; })); },
        clear: function()      { localStorage.removeItem(KEY); window.dispatchEvent(new Event('li:order:updated')); },
        count: function()      { return load().length; },
      };
    })();
  }

  // ── Main init ─────────────────────────────────────────────────────────────
  function init() {
    var root = document.getElementById('li-order-form-root');
    if (!root) return;

    // Inject CSS once
    if (!document.getElementById('li-order-form-styles')) {
      var style = document.createElement('style');
      style.id = 'li-order-form-styles';
      style.textContent = CSS;
      document.head.appendChild(style);
    }

    var apiBase       = root.dataset.apiBase;
    var productHandle = root.dataset.productHandle;
    var productTitle  = root.dataset.productTitle || '';
    var customerId    = root.dataset.customerId   || '';
    var configJson    = root.dataset.formConfig   || '{}';

    // Merge config
    var cfg = Object.assign({}, DEFAULT_CONFIG);
    try { Object.assign(cfg, JSON.parse(configJson)); } catch(e) {}

    var formType = cfg.form_type || '';

    // No form type — show not configured message
    if (!formType) {
      root.innerHTML = '<div style="padding:24px;background:#fff8e1;border:1px solid #ffe082;border-radius:8px;font-family:inherit;">' +
        '<strong>Order form not configured.</strong> Set the <code>custom.li_order_config</code> metafield on this product.' +
        '</div>';
      return;
    }

    // Show loading spinner
    root.innerHTML = '<div style="display:flex;align-items:center;gap:12px;padding:40px;color:#555;">' +
      '<div style="width:20px;height:20px;border:2px solid #333;border-top-color:#8b7355;border-radius:50%;animation:li-spin 0.6s linear infinite;"></div>' +
      'Loading order form…</div>' +
      '<style>@keyframes li-spin{to{transform:rotate(360deg)}}</style>';

    // Fetch from Shopify storefront product.js — no auth needed
    if (productHandle) {
      fetch('/products/' + productHandle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(shopifyProduct) {
          var product = parseShopifyProduct(shopifyProduct);
          mountForm(root, cfg, formType, product, productTitle);
        })
        .catch(function(err) {
          console.warn('[LI Order Form] Could not load product data:', err);
          mountForm(root, cfg, formType, null, productTitle);
        });
    } else {
      mountForm(root, cfg, formType, null, productTitle);
    }
  }


  // ── Parse Shopify storefront product.js into our internal shape ───────────
  // Shopify's /products/HANDLE.js returns a different shape to our backend API
  // This normalises it so all form components work the same way
  function parseShopifyProduct(sp) {
    if (!sp) return null;

    var options = sp.options || [];
    var optionNames = options.map(function(o) { return (o.name || o).toLowerCase(); });

    var designIdx = optionNames.findIndex(function(n) {
      return ['design','designs','style','styles','print','prints','colourway','colourways','pattern','patterns','logo','artwork'].indexOf(n) >= 0;
    });
    var colourIdx = optionNames.findIndex(function(n) {
      return n === 'colour' || n === 'color' || n === 'colors' || n === 'colours' || n === 'color/style' || n === 'colour/style';
    });

    var variants = (sp.variants || []).map(function(v) {
      return {
        id: 'gid://shopify/ProductVariant/' + v.id,
        option1: v.option1,
        option2: v.option2,
        option3: v.option3,
        image: v.featured_image ? { src: v.featured_image.src, alt: v.featured_image.alt || '' } : null,
      };
    });

    // Build variant image lookup: given option values, find the right image
    // Key is "option1||option2" or just "option1" — whichever has an image
    var variantImageMap = {};
    (sp.variants || []).forEach(function(v) {
      if (!v.featured_image) return;
      var img = { src: v.featured_image.src, alt: v.featured_image.alt || '' };
      // Map by option1 alone
      if (v.option1) variantImageMap[v.option1] = img;
      // Map by option1+option2 (more specific wins)
      if (v.option1 && v.option2) variantImageMap[v.option1 + '||' + v.option2] = img;
      // Map by option2 alone (colour only)
      if (v.option2) variantImageMap[v.option2] = variantImageMap[v.option2] || img;
    });

    var designs = designIdx >= 0
      ? [...new Set(variants.map(function(v) { return v['option' + (designIdx + 1)]; }).filter(Boolean))]
      : [];

    var colours = colourIdx >= 0
      ? [...new Set(variants.map(function(v) { return v['option' + (colourIdx + 1)]; }).filter(Boolean))]
      : [];

    // Build design → colour map
    var designColourMap = {};
    if (designIdx >= 0 && colourIdx >= 0) {
      variants.forEach(function(v) {
        var design = v['option' + (designIdx + 1)];
        var colour = v['option' + (colourIdx + 1)];
        if (!design || !colour) return;
        if (!designColourMap[design]) designColourMap[design] = [];
        if (designColourMap[design].indexOf(colour) < 0) designColourMap[design].push(colour);
      });
    }

    // Images — all product images for gallery, with proper src handling
    var images = [];
    if (sp.images && sp.images.length) {
      images = sp.images.map(function(img) {
        // Shopify /products/handle.js returns image URLs as strings
        if (typeof img === 'string') return { src: img, alt: '' };
        // But the Admin API returns objects with .src
        if (img && img.src) return { src: img.src, alt: img.alt || '' };
        return null;
      }).filter(Boolean);
    }
    // Also add any variant images not already in the list
    (sp.variants || []).forEach(function(v) {
      if (!v.featured_image || !v.featured_image.src) return;
      var src = v.featured_image.src;
      if (!images.some(function(i) { return i.src === src; })) {
        images.push({ src: src, alt: v.featured_image.alt || v.option1 || '' });
      }
    });

    // colourHexMap — Shopify storefront doesn't expose swatch hex directly
    // so we return empty and let the CSS fallback handle it
    var colourHexMap = {};

    return {
      id: sp.id,
      title: sp.title,
      handle: sp.handle,
      options: options,
      designs: designs,
      colours: colours,
      colourHexMap: colourHexMap,
      designColourMap: designColourMap,
      colourGarmentMap: {},
      images: images,
      variants: variants,
      variantImageMap: variantImageMap,
    };
  }

  // ── Mount the correct form ────────────────────────────────────────────────
  function mountForm(root, cfg, formType, product, productTitle) {
    // Set gallery images from product — all forms benefit
    galleryImages = (product && product.images) || [];
    galleryIndex  = 0;
    galleryActiveDesign = ''; // reset on each product mount

    switch (formType) {
      case 'dtf':           mountDTFForm(root, cfg, product, productTitle); break;
      case 'screenprint':   mountScreenPrintForm(root, cfg, product, productTitle); break;
      case 'fishing-shirt': mountFishingForm(root, cfg, product, productTitle); break;
      case 'footy-shorts':  mountFootyForm(root, cfg, product, productTitle); break;
      case 'coolers':       mountCoolersForm(root, cfg, product, productTitle); break;
      case 'caps':          mountCapsForm(root, cfg, product, productTitle); break;
      default:              mountAccessoriesForm(root, cfg, product, productTitle); break;
    }
  }

  // ── Shared: render left panel ─────────────────────────────────────────────
  // Gallery images — set per form, referenced by renderLeft
  var galleryImages = [];
  var galleryIndex  = 0;

  // Returns thumb button items filtered by active design
  function renderGalleryThumbItems() {
    var visibleImgs = getGalleryVisible();
    if (!visibleImgs.length) return '';
    return visibleImgs.map(function(entry) {
      return '<button class="lif-gallery-thumb' + (entry.idx === galleryIndex ? ' active' : '') + '" data-gallery-idx="' + entry.idx + '" type="button">' +
        '<img src="' + entry.img.src + '" alt="' + (entry.img.alt || '') + '">' +
      '</button>';
    }).join('');
  }

  // Returns gallery images filtered to match current design (if set)
  function getGalleryVisible() {
    if (!galleryImages.length) return [];
    // If a design is selected, show only images whose alt matches that design
    // Otherwise show all images
    return galleryImages.map(function(img, i) { return { img: img, idx: i }; }).filter(function(entry) {
      if (!galleryActiveDesign) return true;
      // Show image if alt matches design name (case-insensitive) OR no alt text (unassigned = always show)
      var alt = (entry.img.alt || '').toLowerCase();
      return alt === '' || alt === galleryActiveDesign.toLowerCase();
    });
  }

  // Track active design for gallery filtering
  var galleryActiveDesign = '';

  function renderGalleryThumbs() { return ''; } // kept for compat — layout now in renderLeft

  function bindGalleryThumbs() {
    var thumbs = document.querySelectorAll('[data-gallery-idx]');
    thumbs.forEach(function(btn) {
      btn.addEventListener('click', function() {
        galleryIndex = parseInt(btn.dataset.galleryIdx, 10);
        var img = galleryImages[galleryIndex];
        if (img) setPreview(img.src, img.alt);
        thumbs.forEach(function(b) { b.classList.toggle('active', b === btn); });
      });
    });
  }

  function refreshGalleryThumbs() {
    var container = document.getElementById('lif-gallery-thumbs');
    if (!container) return;
    container.innerHTML = renderGalleryThumbItems();
    bindGalleryThumbs();
    // Auto-show first visible image
    var visible = getGalleryVisible();
    if (visible.length) {
      var first = galleryImages[visible[0].idx];
      if (first) setPreview(first.src, first.alt);
    }
  }

  function renderLeft(cfg) {
    var min = cfg.minimum_order || 0;
    return '<div class="lif-left">' +
      '<div class="lif-preview-wrap">' +
        '<div class="lif-gallery-thumbs" id="lif-gallery-thumbs">' + renderGalleryThumbItems() + '</div>' +
        '<div class="lif-preview" id="lif-preview">' +
          '<img id="lif-preview-img" src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" alt="" style="display:none">' +
          '<span class="lif-preview-placeholder" id="lif-preview-placeholder">Select a design to preview</span>' +
        '</div>' +
      '</div>' +
      '<div class="lif-order-lines-box">' +
        '<div class="lif-order-lines-title">Order Lines</div>' +
        '<div id="lif-order-lines"><div class="lif-order-empty">No items added yet</div></div>' +
        '<div class="lif-summary-rows">' +
          '<div class="lif-summary-row" id="lif-sum-method-row" style="display:none"><span>Print method</span><span id="lif-sum-method"></span></div>' +
          '<div class="lif-summary-row" id="lif-sum-setup-row" style="display:none"><span>Screen setup</span><span id="lif-sum-setup"></span></div>' +
          '<div class="lif-summary-row" id="lif-sum-bagging-row" style="display:none"><span>Bagging</span><span id="lif-sum-bagging"></span></div>' +
          '<div class="lif-summary-row" id="lif-sum-units-row"><span>Total units</span><span id="lif-sum-units">0</span></div>' +
          '<div class="lif-summary-row total"><span>Grand total</span><span id="lif-sum-grand">$0.00</span></div>' +
        '</div>' +
      '</div>' +
      '<div class="lif-stored-banner" id="lif-stored-banner"></div>' +
      '<button class="lif-submit-btn" id="lif-submit-btn" type="button">Submit order request</button>' +
      '<a href="/cart" class="lif-view-order-btn" id="lif-view-order-btn">View order (<span id="lif-order-count">0</span> lines) &rarr;</a>' +
    '</div>';
  }

  // ── Shared: update left panel after line changes ──────────────────────────
  function updateSummary(cfg, formType, extras) {
    extras = extras || {};
    var linesEl = el('lif-order-lines');
    var units = totalUnits();
    var total = grandTotal();
    var min = cfg.minimum_order || 0;

    // Render order lines
    if (orderLines.length === 0) {
      linesEl.innerHTML = '<div class="lif-order-empty">No items added yet</div>';
    } else {
      linesEl.innerHTML = orderLines.map(function(line) {
        var sizesHtml = '';
        if (line.sizes) {
          var sizeChips = Object.keys(line.sizes).filter(function(s) { return line.sizes[s] > 0; })
            .map(function(s) { return '<span class="lif-order-line-size">' + s + ': ' + line.sizes[s] + '</span>'; }).join('');
          if (sizeChips) sizesHtml = '<div class="lif-order-line-sizes">' + sizeChips + '</div>';
        }
        var detail = [
          line.colour ? 'Colour: ' + line.colour : '',
          line.garmentLabel ? 'Garment: ' + line.garmentLabel : '',
          line.style && line.style !== 'Normal' ? 'Style: ' + line.style : '',
          line.sleeveType ? 'Sleeve: ' + line.sleeveType : '',
          line.qty && !line.sizes ? 'Qty: ' + line.qty : '',
        ].filter(Boolean).join(' · ');
        return '<div class="lif-order-line">' +
          '<div class="lif-order-line-header">' +
            '<span class="lif-order-line-label">' + (line.design || line.label || 'Line ' + line.id) + '</span>' +
            '<button class="lif-order-line-remove" data-id="' + line.id + '" type="button">&times;</button>' +
          '</div>' +
          (detail ? '<div class="lif-order-line-detail">' + detail + '</div>' : '') +
          sizesHtml +
          '<div class="lif-order-line-total">' + fmt(line.lineTotal) + '</div>' +
        '</div>';
      }).join('');

      // Attach remove listeners
      linesEl.querySelectorAll('.lif-order-line-remove').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var id = parseInt(btn.dataset.id, 10);
          orderLines = orderLines.filter(function(l) { return l.id !== id; });
          if (window.LIOrder) window.LIOrder.remove(id);
          updateSummary(cfg, formType, extras);
          if (extras.onRemove) extras.onRemove();
        });
      });
    }

    // Update totals
    if (el('lif-sum-units')) el('lif-sum-units').textContent = units;
    if (el('lif-sum-grand')) el('lif-sum-grand').textContent = fmt(total);

    // Submit button state
    var submitBtn = el('lif-submit-btn');
    if (submitBtn) {
      var canSubmit = units >= min && orderLines.length > 0;
      submitBtn.classList.toggle('enabled', canSubmit);
      submitBtn.textContent = canSubmit ? 'Submit order request' : (min > 0 && units < min ? 'Minimum ' + min + ' units (' + units + '/' + min + ')' : 'Submit order request');
    }

    // View order count — shown in stored banner, no /cart link needed
    var viewBtn = el('lif-view-order-btn');
    if (viewBtn) viewBtn.style.display = 'none'; // draft order system — cart not used

    // Stored banner (from li-order-store.js localStorage)
    updateStoredBanner();
  }

  function updateStoredBanner() {
    var banner = el('lif-stored-banner');
    if (!banner) return;
    var liCount = window.LIOrder ? window.LIOrder.count() : 0;
    if (liCount > 0) {
      banner.innerHTML = '✓ ' + liCount + ' line' + (liCount===1?'':'s') + ' in your cart across all products — <a href="/cart" style="color:inherit;font-weight:600;">view order &rarr;</a>';
      banner.classList.add('visible');
    } else {
      banner.classList.remove('visible');
    }
  }

  window.addEventListener('li:order:updated', updateStoredBanner);

  // ── Shared: preview image updater ─────────────────────────────────────────
  function setPreview(src, alt) {
    var img = el('lif-preview-img');
    var placeholder = el('lif-preview-placeholder');
    if (!img) return;
    if (src) {
      img.src = src;
      img.alt = alt || '';
      img.style.display = '';
      if (placeholder) placeholder.style.display = 'none';
    } else {
      img.style.display = 'none';
      if (placeholder) placeholder.style.display = '';
    }
  }

  function findImage(images, design, colour, variantImageMap) {
    // Priority: use variant image map (keyed by option values from Shopify variants)
    if (variantImageMap) {
      // Try design+colour combo first
      if (design && colour) {
        var both = variantImageMap[design + '||' + colour];
        if (both) return both;
      }
      // Try colour only
      if (colour) {
        var byColour = variantImageMap[colour];
        if (byColour) return byColour;
      }
      // Try design only
      if (design) {
        var byDesign = variantImageMap[design];
        if (byDesign) return byDesign;
      }
    }
    // Fall back to first product image
    return (images && images[0]) || null;
  }

  // ── Shared: tier bar renderer ─────────────────────────────────────────────
  function renderTierBar(tiers, currentUnits, garmentLabel) {
    return '<div class="lif-tier-bar">' +
      tiers.slice().reverse().map(function(tier) {
        var isActive = currentUnits >= tier.min;
        return '<div class="lif-tier-card ' + (isActive ? 'active' : '') + '">' +
          '<span class="lif-tier-min">' + tier.min + '+ units</span>' +
          '<span class="lif-tier-price">' + (garmentLabel || '') + ' ' + fmt(tier.price) + '</span>' +
        '</div>';
      }).join('') +
    '</div>' +
    '<div class="lif-tier-msg" id="lif-tier-msg">Add combinations to see your live pricing.</div>';
  }

  // ── Shared: submit handler ────────────────────────────────────────────────
  function attachSubmit(root, cfg, formType) {
    var btn = el('lif-submit-btn');
    if (!btn || btn.dataset.submitBound) return;
    btn.dataset.submitBound = '1';
    btn.addEventListener('click', function() {
      if (!btn.classList.contains('enabled')) return;
      doSubmit(root, cfg, formType);
    });
  }

  function doSubmit(root, cfg, formType) {
    var apiBase    = root.dataset.apiBase;
    var customerId = root.dataset.customerId || '';
    var btn = el('lif-submit-btn');
    if (btn) { btn.textContent = 'Submitting…'; btn.classList.remove('enabled'); }

    // Fetch customer email if we have a customer ID, then submit
    var emailPromise = customerId
      ? fetch(apiBase + '/api/draft-orders/customer/' + customerId).then(function(r){ return r.json(); }).then(function(d){ return d.email||''; }).catch(function(){ return ''; })
      : Promise.resolve('');

    emailPromise.then(function(customerEmail) {
    fetch(apiBase + '/api/draft-orders', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        orderLines: orderLines,
        productType: formType,
        customerEmail: customerEmail,
        note: '',
      }),
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (!data.success) throw new Error(data.error || 'Submission failed');
      // Clear order
      orderLines = [];
      if (window.LIOrder) window.LIOrder.clear();
      // Show success
      root.innerHTML = '<div class="lif-root"><div class="lif-success">' +
        '<div class="lif-success-icon">✓</div>' +
        '<div class="lif-success-title">Order submitted!</div>' +
        '<div class="lif-success-msg">Your order <strong>' + (data.draftOrderNumber || '') + '</strong> has been received. We\'ll be in touch shortly with an invoice.</div>' +
        (data.invoiceUrl ? '<a href="' + data.invoiceUrl + '" class="lif-success-link" target="_blank">View order &amp; invoice &rarr;</a>' : '') +
      '</div></div>';
    })
    .catch(function(err) {
      alert('Submission failed: ' + err.message + '\n\nPlease contact Lucky Inger directly.');
      if (btn) { btn.textContent = 'Submit order request'; btn.classList.add('enabled'); }
    });
    }); // end emailPromise.then
  }

  // ══════════════════════════════════════════════════════════════════════════
  // DTF FORM
  // ══════════════════════════════════════════════════════════════════════════
  function mountDTFForm(root, cfg, product, productTitle) {
    var designs   = (product && product.designs)   || [];
    var colours   = (product && product.colours)   || [];
    var images    = (product && product.images)    || [];
    var hexMap    = (product && product.colourHexMap) || {};
    var designColourMap = (product && product.designColourMap) || {};
    var variantImageMap = (product && product.variantImageMap) || {};

    var selDesign = designs.length > 0 ? designs[0] : '';
    var selColour = '';
    var selGarment = cfg.show_adult_tee !== false ? 'atee' : (cfg.show_adult_hood ? 'ahood' : (cfg.show_adult_sweat ? 'asweat' : 'ktee'));
    var selStyle  = 'Normal'; // No Zip / Full Zip / Sweater
    var sizeValues = {};
    var bagging = false;
    var colourFilterEnabled = Object.keys(designColourMap).length > 0;

    // Build garment tabs
    var garmentTabs = [
      { key: 'atee',   label: 'Adult tees',     show: cfg.show_adult_tee  !== false, infoKey: 'atee_info'   },
      { key: 'ktee',   label: 'Kids tees',      show: !!cfg.show_kids_tee,           infoKey: 'ktee_info'   },
      { key: 'ahood',  label: 'Adult hoods',    show: cfg.show_adult_hood !== false, infoKey: 'ahood_info'  },
      { key: 'khood',  label: 'Kids hoods',     show: !!cfg.show_kids_hood,          infoKey: 'khood_info'  },
      { key: 'asweat', label: 'Adult sweaters', show: !!cfg.show_adult_sweat,        infoKey: 'asweat_info' },
      { key: 'ksweat', label: 'Kids sweaters',  show: !!cfg.show_kids_sweat,         infoKey: 'ksweat_info' },
    ].filter(function(t) { return t.show; });

    if (!garmentTabs.find(function(t) { return t.key === selGarment; })) {
      selGarment = garmentTabs[0] ? garmentTabs[0].key : 'atee';
    }

    function isHood(g)  { return g === 'ahood' || g === 'khood'; }
    function isSweat(g) { return g === 'asweat' || g === 'ksweat'; }
    function isAdult(g) { return g === 'atee' || g === 'ahood' || g === 'asweat'; }
    function hasSizeCap(g) { return g === 'atee' || g === 'ahood' || g === 'asweat'; }

    function getAvailableColours() {
      if (!selDesign || !colourFilterEnabled || !designColourMap[selDesign]) return colours;
      return designColourMap[selDesign];
    }

    function recalc() {
      var tiers = getTiers(cfg, selGarment);
      var formUnits = Object.values(sizeValues).reduce(function(s, v) { return s + (v || 0); }, 0);
      var allUnits = totalUnits() + formUnits;
      var unitPrice = getTierPrice(tiers, allUnits);

      // Calculate line total including oversize and zip surcharges
      var garmentTotal = 0;
      var sizes = SIZES[selGarment] || [];
      sizes.forEach(function(size) {
        var q = sizeValues[size] || 0;
        if (!q) return;
        var ovSurch = (selGarment === 'atee') ? getOversizeSurcharge(cfg, size) : 0;
        var zipSurch = (isHood(selGarment) && selStyle === 'Full Zip') ? (cfg.full_zip_surcharge || 7.70) : 0;
        garmentTotal += q * (unitPrice + ovSurch + zipSurch);
      });

      var baggingFee = bagging ? formUnits * (cfg.bagging_rate || 1.70) : 0;
      var lineTotal = garmentTotal + baggingFee;

      // Update size row prices
      sizes.forEach(function(size) {
        var priceEl = el('lif-size-price-' + size.replace('/', ''));
        if (priceEl) {
          var ovSurch = (selGarment === 'atee') ? getOversizeSurcharge(cfg, size) : 0;
          var zipSurch = (isHood(selGarment) && selStyle === 'Full Zip') ? (cfg.full_zip_surcharge || 7.70) : 0;
          var total = unitPrice + ovSurch + zipSurch;
          priceEl.textContent = total > 0 ? fmt(total) + ' each (from)' : '-';
        }
      });

      // Live-update tier bar cards without full re-render
      var tierCards = root.querySelectorAll('.lif-tier-card');
      var reversedTiers = tiers.slice().reverse();
      tierCards.forEach(function(card, i) {
        if (reversedTiers[i]) {
          card.classList.toggle('active', allUnits >= reversedTiers[i].min);
        }
      });
      var newTierMsg = el('lif-tier-msg');
      if (newTierMsg) {
        newTierMsg.textContent = formUnits > 0
          ? 'Current: ' + fmt(unitPrice) + '/unit · ' + getTierLabel(tiers, allUnits)
          : 'Add combinations to see your live pricing.';
      }

      return { formUnits: formUnits, lineTotal: lineTotal, unitPrice: unitPrice };
    }

    function render() {
      var availableColours = getAvailableColours();
      var sizes = SIZES[selGarment] || [];
      var tiers = getTiers(cfg, selGarment);
      var formUnits = Object.values(sizeValues).reduce(function(s, v) { return s + (v || 0); }, 0);
      var allUnits = totalUnits() + formUnits;

      var html = '<div class="lif-root"><div class="lif-wrap">' + renderLeft(cfg) + '<div class="lif-right">';

      // Step 1 — Design
      if (designs.length > 1) {
        html += '<div class="lif-step">';
        html += '<p class="lif-section-label">Step 1 &mdash; Select your design</p>';
        html += '<div class="lif-select-wrap"><select class="lif-select" id="lif-design-sel">';
        html += '<option value="">Select a design &#9662;</option>';
        designs.forEach(function(d) {
          html += '<option value="' + d + '"' + (selDesign === d ? ' selected' : '') + '>' + d + '</option>';
        });
        html += '</select></div></div>';
      } else if (designs.length === 1) {
        html += '<div class="lif-step">';
        html += '<p class="lif-section-label">Design</p>';
        html += '<div class="lif-design-display">' + designs[0] + '</div>';
        html += '</div>';
      }

      // Step 2 — Colour
      if (availableColours.length > 0) {
        var stepNum = designs.length > 0 ? 2 : 1;
        html += '<div class="lif-step">';
        html += '<p class="lif-section-label">Step ' + stepNum + ' &mdash; Select garment colour</p>';
        html += '<div class="lif-colour-card">';
        html += '<p class="lif-colour-card-title">Garment colour</p>';
        html += '<p class="lif-colour-card-sub">Selecting a colour updates the preview image.</p>';
        html += '<div class="lif-colour-pills">';
        availableColours.forEach(function(col) {
          var hex = getSwatchColour(col, hexMap);
          html += '<button class="lif-colour-pill' + (selColour === col ? ' active' : '') + '" data-colour="' + col + '" type="button">';
          html += '<span class="lif-colour-dot" style="background:' + hex + ';"></span>';
          html += col;
          html += '<span class="lif-colour-check"><svg width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
          html += '</button>';
        });
        html += '</div></div></div>';
      }

      // Step 3 — Garment + Sizes
      var stepNum3 = 1 + (designs.length > 0 ? 1 : 0) + (availableColours.length > 0 ? 1 : 0);
      html += '<div class="lif-step">';
      html += '<p class="lif-section-label">Step ' + stepNum3 + ' &mdash; Select garment &amp; enter quantities</p>';
      html += '<div class="lif-garment-card">';

      // Garment tabs
      html += '<div class="lif-garment-tabs">';
      garmentTabs.forEach(function(t) {
        html += '<button class="lif-garment-tab' + (selGarment === t.key ? ' active' : '') + '" data-garment="' + t.key + '" type="button">' + t.label + '</button>';
      });
      html += '</div>';

      // Garment info bar
      var infoKey = garmentTabs.find(function(t) { return t.key === selGarment; });
      if (infoKey && cfg[infoKey.infoKey]) {
        html += '<div class="lif-garment-info">' + cfg[infoKey.infoKey] + '</div>';
      }

      // Hood style pills
      if (isHood(selGarment)) {
        var zipSurch = cfg.full_zip_surcharge || 7.70;
        html += '<div class="lif-style-pills">';
        ['Normal', 'Full Zip'].forEach(function(style) {
          html += '<button class="lif-style-pill' + (selStyle === style ? ' active' : '') + '" data-style="' + style + '" type="button">';
          html += style + (style === 'Full Zip' ? ' (+' + fmt(zipSurch) + '/unit)' : '');
          html += '</button>';
        });
        html += '</div>';
      }

      // Cap warning bar
      var capWarn = hasSizeCap(selGarment) ? getCapWarning(cfg, selGarment, selColour) : '';
      if (capWarn) {
        html += '<div class="lif-garment-info" style="color:#c0392b;">' + capWarn + '</div>';
      }

      // Size rows
      html += '<div class="lif-size-rows">';
      sizes.forEach(function(size) {
        var safeId = size.replace('/', '');
        var qty = sizeValues[size] || 0;
        var isCapped = hasSizeCap(selGarment) && isColourCapped(cfg, selGarment, selColour, size);
        html += '<div class="lif-size-row' + (isCapped ? ' hidden' : '') + '">';
        html += '<span class="lif-size-label">' + size + '</span>';
        html += '<span class="lif-size-price" id="lif-size-price-' + safeId + '">-</span>';
        html += '<div class="lif-size-stepper">';
        html += '<button class="lif-stepper-btn" data-size="' + size + '" data-delta="-1" type="button">&#8722;</button>';
        html += '<input class="lif-stepper-input" id="lif-size-inp-' + safeId + '" type="number" min="0" value="' + (qty || '') + '" placeholder="0" data-size="' + size + '">';
        html += '<button class="lif-stepper-btn" data-size="' + size + '" data-delta="1" type="button">+</button>';
        html += '</div></div>';
      });
      html += '</div>';

      // Bagging
      if (cfg.show_bagging) {
        html += '<div class="lif-fee-row">';
        html += '<input type="checkbox" id="lif-bagging" ' + (bagging ? 'checked' : '') + '>';
        html += '<label for="lif-bagging">Include bagging <span class="lif-fee-amount">(' + fmt(cfg.bagging_rate || 1.70) + '/unit)</span></label>';
        html += '</div>';
      }

      // Add combination button
      html += '<button class="lif-add-combo-btn" id="lif-add-combo" type="button">+ Add this combination to order</button>';
      html += '<div class="lif-msg" id="lif-msg"></div>';

      // Tier bar
      html += renderTierBar(tiers, allUnits, '');

      html += '</div></div></div></div></div>';

      root.innerHTML = html;

      // Attach events
      // Design select
      var designSel = el('lif-design-sel');
      if (designSel) {
        designSel.addEventListener('change', function() {
          selDesign = this.value;
          // Filter colours
          var newColours = getAvailableColours();
          if (selColour && newColours.indexOf(selColour) < 0) selColour = newColours[0] || '';
          updatePreview();
          render();
        });
      }

      // Colour pills
      root.querySelectorAll('.lif-colour-pill').forEach(function(pill) {
        pill.addEventListener('click', function() {
          selColour = pill.dataset.colour;
          galleryActiveDesign = selColour; refreshGalleryThumbs();
          // Clear any sizes that become capped for this colour/garment combo
          if (hasSizeCap(selGarment)) {
            OVERSIZE_SIZES.forEach(function(s) {
              if (isColourCapped(cfg, selGarment, selColour, s)) {
                sizeValues[s] = 0;
              }
            });
          }
          updatePreview();
          render();
        });
      });

      // Garment tabs
      root.querySelectorAll('.lif-garment-tab').forEach(function(tab) {
        tab.addEventListener('click', function() {
          selGarment = tab.dataset.garment;
          sizeValues = {};
          render();
        });
      });

      // Style pills
      root.querySelectorAll('.lif-style-pill').forEach(function(pill) {
        pill.addEventListener('click', function() {
          selStyle = pill.dataset.style;
          render();
        });
      });

      // Stepper buttons
      root.querySelectorAll('.lif-stepper-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var size = btn.dataset.size;
          var delta = parseInt(btn.dataset.delta, 10);
          sizeValues[size] = Math.max(0, (sizeValues[size] || 0) + delta);
          var inp = el('lif-size-inp-' + size.replace('/', ''));
          if (inp) inp.value = sizeValues[size] || '';
          var msgEl = el('lif-msg'); if (msgEl) msgEl.className = 'lif-msg';
          recalc();
        });
      });

      // Size inputs
      root.querySelectorAll('.lif-stepper-input').forEach(function(inp) {
        inp.addEventListener('input', function() {
          var v = parseInt(inp.value, 10);
          sizeValues[inp.dataset.size] = isNaN(v) ? 0 : Math.max(0, v);
          var msgEl = el('lif-msg'); if (msgEl) msgEl.className = 'lif-msg';
          recalc();
        });
      });

      // Bagging
      var baggingCb = el('lif-bagging');
      if (baggingCb) {
        baggingCb.addEventListener('change', function() { bagging = this.checked; recalc(); });
      }

      // Add combo
      var addBtn = el('lif-add-combo');
      if (addBtn) {
        addBtn.addEventListener('click', function() { addCombo(); });
      }

      // Recalc now to populate prices
      recalc();
      updatePreview();
      updateSummary(cfg, 'dtf', { onRemove: function() { render(); } });
      attachSubmit(root, cfg, 'dtf');
    }

    function updatePreview() {
      var img = findImage(images, selDesign, selColour, variantImageMap);
      if (img) setPreview(img.src, img.alt);
      else setPreview(null);
    }

    function addCombo() {
      var msgEl = el('lif-msg');
      if (designs.length > 1 && !selDesign) { showMsg(msgEl, 'error', 'Please select a design.'); return; }
      if (colours.length > 0 && !selColour) { showMsg(msgEl, 'error', 'Please select a colour.'); return; }

      // Filter out capped sizes before adding to order
      var sizesFiltered = {};
      var formUnits = 0;
      Object.keys(sizeValues).forEach(function(s) {
        if (!sizeValues[s] || sizeValues[s] <= 0) return;
        if (hasSizeCap(selGarment) && isColourCapped(cfg, selGarment, selColour, s)) return;
        sizesFiltered[s] = sizeValues[s];
        formUnits += sizeValues[s];
      });
      if (formUnits === 0) { showMsg(msgEl, 'error', 'Enter at least 1 unit.'); return; }

      var tiers = getTiers(cfg, selGarment);
      var allUnits = totalUnits() + formUnits;
      var unitPrice = getTierPrice(tiers, allUnits);
      var garmentLabel = { atee: 'Adult Tee', ktee: 'Kids Tee', ahood: 'Adult Hoodie', khood: 'Kids Hoodie', asweat: 'Adult Sweater', ksweat: 'Kids Sweater' }[selGarment] || selGarment;

      // Calc total with oversize + zip
      var lineTotal = 0;
      Object.keys(sizesFiltered).forEach(function(size) {
        var q = sizesFiltered[size];
        var ovSurch = (selGarment === 'atee') ? getOversizeSurcharge(cfg, size) : 0;
        var zipSurch = (isHood(selGarment) && selStyle === 'Full Zip') ? (cfg.full_zip_surcharge || 7.70) : 0;
        lineTotal += q * (unitPrice + ovSurch + zipSurch);
      });
      if (bagging) lineTotal += formUnits * (cfg.bagging_rate || 1.70);

      orderLines.push({
        id: ++lineIdCounter,
        design: selDesign,
        colour: selColour,
        garmentType: selGarment,
        garmentLabel: garmentLabel,
        style: selStyle,
        sizes: sizesFiltered,
        units: formUnits,
        unitPrice: unitPrice,
        tier: getTierLabel(tiers, allUnits),
        lineTotal: lineTotal,
        printMethod: 'DTF',
        bagging: bagging,
      });

      // Reset sizes and re-render to clear inputs
      sizeValues = {};
      render();
      showMsg(el('lif-msg'), 'success', 'Added! Keep adding combinations or submit your order.');
      setTimeout(function() { var m = el('lif-msg'); if (m) m.className = 'lif-msg'; }, 2500);
    }

    render();
  }

  // ══════════════════════════════════════════════════════════════════════════
  // SCREEN PRINT FORM
  // ══════════════════════════════════════════════════════════════════════════
  function mountScreenPrintForm(root, cfg, product, productTitle) {
    var colours  = (product && product.colours)  || [];
    var images   = (product && product.images)   || [];
    var hexMap   = (product && product.colourHexMap) || {};
    var colourGarmentMap = (product && product.colourGarmentMap) || {};
    var productTitle = (product && product.title) || '';
    var variantImageMap = (product && product.variantImageMap) || {};

    var selColour  = colours[0] || '';
    var selGarment = cfg.show_adult_tee !== false ? 'atee' : 'ahood';
    var selStyle   = 'Normal';
    var sizeValues = {};
    var setupAlreadyPaid = false;
    var bagging = false;

    var garmentTabs = [
      { key: 'atee',  label: 'Tees',        show: cfg.show_adult_tee !== false },
      { key: 'ktee',  label: 'Kids Tees',   show: !!cfg.show_kids_tee },
      { key: 'ahood', label: 'Hoods',       show: cfg.show_adult_hood !== false },
      { key: 'khood', label: 'Kids Hoods',  show: !!cfg.show_kids_hood },
    ].filter(function(t) { return t.show; });

    function isHood(g) { return g === 'ahood' || g === 'khood'; }
    function isAdult(g) { return g === 'atee' || g === 'ahood'; }

    function garmentAvailable(garmentKey) {
      if (!selColour || !colourGarmentMap[selColour]) return true; // no image data — assume available
      var map = colourGarmentMap[selColour];
      if (garmentKey === 'atee' || garmentKey === 'ktee') return map.tee !== false;
      if (garmentKey === 'ahood' || garmentKey === 'khood') return map.hood !== false;
      return true;
    }

    function recalc() {
      var tiers = getTiers(cfg, 'sp_' + selGarment);
      var formUnits = Object.values(sizeValues).reduce(function(s, v) { return s + (v || 0); }, 0);
      var allUnits = totalUnits() + formUnits;
      var unitPrice = getTierPrice(tiers, allUnits);

      var sizes = SIZES[selGarment] || [];
      sizes.forEach(function(size) {
        var priceEl = el('lif-size-price-' + size.replace('/', ''));
        if (!priceEl) return;
        var zipSurch = (isHood(selGarment) && selStyle === 'Full Zip') ? (cfg.full_zip_surcharge || 7.70) : 0;
        priceEl.textContent = unitPrice > 0 ? fmt(unitPrice + zipSurch) + ' each (from)' : '-';
      });

      var newTierMsg = el('lif-tier-msg');
      if (newTierMsg) {
        newTierMsg.textContent = formUnits > 0
          ? 'Current: ' + fmt(unitPrice) + '/unit · ' + getTierLabel(tiers, allUnits)
          : 'Add combinations to see your live pricing.';
      }
    }

    function render() {
      var tiers = getTiers(cfg, 'sp_' + selGarment);
      var sizes = SIZES[selGarment] || [];
      var formUnits = Object.values(sizeValues).reduce(function(s, v) { return s + (v || 0); }, 0);
      var allUnits = totalUnits() + formUnits;

      var html = '<div class="lif-root"><div class="lif-wrap">' + renderLeft(cfg) + '<div class="lif-right">';

      // Setup fee card
      if (cfg.show_setup_fee) {
        html += '<div class="lif-setup-card">';
        html += '<p class="lif-setup-question">Has this design been screen printed with us before?</p>';
        html += '<p class="lif-setup-sub">If yes, your ' + fmt(cfg.setup_fee || 990) + ' screen setup fee has already been paid and will not be charged again.</p>';
        html += '<div class="lif-setup-btns">';
        html += '<button class="lif-setup-btn' + (!setupAlreadyPaid ? ' active' : '') + '" data-answer="no" type="button">No &mdash; first time printing this design</button>';
        html += '<button class="lif-setup-btn' + (setupAlreadyPaid ? ' active' : '') + '" data-answer="yes" type="button">Yes &mdash; setup already paid</button>';
        html += '</div></div>';
      }

      // Step 1 — Colour
      html += '<div class="lif-step">';
      html += '<p class="lif-section-label">Step 1 &mdash; Select garment colour</p>';
      html += '<div class="lif-colour-card">';
      html += '<p class="lif-colour-card-title">Garment colour</p>';
      if (cfg.show_colour_surcharge) {
        html += '<span class="lif-colour-surcharge-badge">&#9888; Black is included. Each additional colour incurs a ' + fmt(cfg.colour_surcharge || 99) + ' surcharge.</span>';
      }
      html += '<div class="lif-colour-pills">';
      colours.forEach(function(col) {
        var hex = getSwatchColour(col, hexMap);
        html += '<button class="lif-colour-pill' + (selColour === col ? ' active' : '') + '" data-colour="' + col + '" type="button">';
        html += '<span class="lif-colour-dot" style="background:' + hex + ';"></span>';
        html += col;
        html += '<span class="lif-colour-check"><svg width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
        html += '</button>';
      });
      html += '</div></div></div>';

      // Step 2 — Garment + Sizes
      html += '<div class="lif-step">';
      html += '<p class="lif-section-label">Step 2 &mdash; Select garment &amp; enter quantities</p>';
      html += '<div class="lif-garment-card">';

      // Garment tabs
      html += '<div class="lif-garment-tabs">';
      garmentTabs.forEach(function(t) {
        var available = garmentAvailable(t.key);
        html += '<button class="lif-garment-tab' + (selGarment === t.key ? ' active' : '') + (available ? '' : ' hidden') + '" data-garment="' + t.key + '" type="button">' + t.label + '</button>';
      });
      html += '</div>';

      // Garment info
      var infoMap = { atee: 'atee_info', ktee: 'ktee_info', ahood: 'ahood_info', khood: 'khood_info' };
      if (cfg[infoMap[selGarment]]) html += '<div class="lif-garment-info">' + cfg[infoMap[selGarment]] + '</div>';

      // Hood style
      if (isHood(selGarment)) {
        var zipSurch = cfg.full_zip_surcharge || 7.70;
        html += '<div class="lif-style-pills">';
        ['Normal', 'Full Zip'].forEach(function(style) {
          html += '<button class="lif-style-pill' + (selStyle === style ? ' active' : '') + '" data-style="' + style + '" type="button">' + style + (style === 'Full Zip' ? ' (+' + fmt(zipSurch) + '/unit)' : '') + '</button>';
        });
        html += '</div>';
      }

      // Cap warning bar
      var spCapWarn = isAdult(selGarment) ? getCapWarning(cfg, selGarment, selColour) : '';
      if (spCapWarn) {
        html += '<div class="lif-garment-info" style="color:#c0392b;">' + spCapWarn + '</div>';
      }

      // Size rows
      html += '<div class="lif-size-rows">';
      sizes.forEach(function(size) {
        var safeId = size.replace('/', '');
        var qty = sizeValues[size] || 0;
        var isCapped = isAdult(selGarment) && isColourCapped(cfg, selGarment, selColour, size);
        html += '<div class="lif-size-row' + (isCapped ? ' hidden' : '') + '">';
        html += '<span class="lif-size-label">' + size + '</span>';
        html += '<span class="lif-size-price" id="lif-size-price-' + safeId + '">-</span>';
        html += '<div class="lif-size-stepper">';
        html += '<button class="lif-stepper-btn" data-size="' + size + '" data-delta="-1" type="button">&#8722;</button>';
        html += '<input class="lif-stepper-input" type="number" min="0" value="' + (qty || '') + '" placeholder="0" data-size="' + size + '">';
        html += '<button class="lif-stepper-btn" data-size="' + size + '" data-delta="1" type="button">+</button>';
        html += '</div></div>';
      });
      html += '</div>';

      // Fees
      if (cfg.show_bagging) {
        html += '<div class="lif-fee-row"><input type="checkbox" id="lif-bagging"' + (bagging ? ' checked' : '') + '><label for="lif-bagging">Include bagging <span class="lif-fee-amount">(' + fmt(cfg.bagging_rate || 1.70) + '/unit)</span></label></div>';
      }

      html += '<button class="lif-add-combo-btn" id="lif-add-combo" type="button">+ Add this combination to order</button>';
      html += '<div class="lif-msg" id="lif-msg"></div>';
      html += renderTierBar(tiers, allUnits, '');
      html += '</div></div></div></div></div>';

      root.innerHTML = html;

      // Events
      root.querySelectorAll('.lif-setup-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          setupAlreadyPaid = btn.dataset.answer === 'yes';
          render();
        });
      });

      root.querySelectorAll('.lif-colour-pill').forEach(function(pill) {
        pill.addEventListener('click', function() {
          selColour = pill.dataset.colour;
          // Reset garment if not available for new colour
          if (!garmentAvailable(selGarment)) {
            var first = garmentTabs.find(function(t) { return garmentAvailable(t.key); });
            if (first) selGarment = first.key;
          }
          var img = findImage(images, null, selColour, variantImageMap);
          if (img) setPreview(img.src, img.alt);
          render();
        });
      });

      root.querySelectorAll('.lif-garment-tab').forEach(function(tab) {
        tab.addEventListener('click', function() {
          selGarment = tab.dataset.garment;
          sizeValues = {};
          render();
        });
      });

      root.querySelectorAll('.lif-style-pill').forEach(function(pill) {
        pill.addEventListener('click', function() { selStyle = pill.dataset.style; render(); });
      });

      root.querySelectorAll('.lif-stepper-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var size = btn.dataset.size;
          sizeValues[size] = Math.max(0, (sizeValues[size] || 0) + parseInt(btn.dataset.delta, 10));
          var inp = root.querySelector('[data-size="' + size + '"].lif-stepper-input');
          if (inp) inp.value = sizeValues[size] || '';
          recalc();
        });
      });

      root.querySelectorAll('.lif-stepper-input').forEach(function(inp) {
        inp.addEventListener('input', function() {
          var v = parseInt(inp.value, 10);
          sizeValues[inp.dataset.size] = isNaN(v) ? 0 : Math.max(0, v);
          recalc();
        });
      });

      var baggingCb = el('lif-bagging');
      if (baggingCb) baggingCb.addEventListener('change', function() { bagging = this.checked; recalc(); });

      var addBtn = el('lif-add-combo');
      if (addBtn) addBtn.addEventListener('click', addCombo);

      recalc();
      if (selColour) { var img = findImage(images, null, selColour, variantImageMap); if (img) setPreview(img.src, img.alt); }
      updateSummary(cfg, 'screenprint', { onRemove: function() { render(); } });
      attachSubmit(root, cfg, 'screenprint');
    }

    function addCombo() {
      var msgEl = el('lif-msg');
      if (!selColour) { showMsg(msgEl, 'error', 'Please select a colour.'); return; }
      if (!garmentAvailable(selGarment)) { showMsg(msgEl, 'error', garmentTabs.find(function(t){return t.key===selGarment;}).label + ' not available for ' + selColour + '.'); return; }

      var sizesFiltered = {};
      var formUnits = 0;
      Object.keys(sizeValues).forEach(function(s) { if (sizeValues[s] > 0) { sizesFiltered[s] = sizeValues[s]; formUnits += sizeValues[s]; } });
      if (!formUnits) { showMsg(msgEl, 'error', 'Enter at least 1 unit.'); return; }

      var tiers = getTiers(cfg, 'sp_' + selGarment);
      var allUnits = totalUnits() + formUnits;
      var unitPrice = getTierPrice(tiers, allUnits);
      var zipSurch = (isHood(selGarment) && selStyle === 'Full Zip') ? (cfg.full_zip_surcharge || 7.70) : 0;
      var colourSurcharge = cfg.show_colour_surcharge && selColour.toLowerCase() !== 'black' ? (cfg.colour_surcharge || 99) : 0;
      var setupFee = cfg.show_setup_fee && !setupAlreadyPaid ? (cfg.setup_fee || 990) : 0;
      var garmentTotal = formUnits * (unitPrice + zipSurch);
      var baggingFee = bagging ? formUnits * (cfg.bagging_rate || 1.70) : 0;
      var lineTotal = garmentTotal + colourSurcharge + setupFee + baggingFee;

      var garmentLabel = { atee: 'Adult Tee', ktee: 'Kids Tee', ahood: 'Adult Hoodie', khood: 'Kids Hoodie', asweat: 'Adult Sweater', ksweat: 'Kids Sweater' }[selGarment] || selGarment;

      orderLines.push({
        id: ++lineIdCounter,
        design: productTitle,
        colour: selColour,
        garmentType: selGarment,
        garmentLabel: garmentLabel,
        style: selStyle,
        sizes: sizesFiltered,
        units: formUnits,
        unitPrice: unitPrice,
        tier: getTierLabel(tiers, allUnits),
        lineTotal: lineTotal,
        printMethod: 'Screen Print',
        setupFee: setupFee,
        colourSurcharge: colourSurcharge,
        baggingFee: baggingFee,
      });

      sizeValues = {};
      setupAlreadyPaid = true; // waived after first add
      render();
      showMsg(el('lif-msg'), 'success', 'Added! Keep adding combinations or submit.');
      setTimeout(function() { var m = el('lif-msg'); if (m) m.className = 'lif-msg'; }, 2500);
    }

    render();
  }

  // ══════════════════════════════════════════════════════════════════════════
  // FISHING SHIRT FORM
  // ══════════════════════════════════════════════════════════════════════════
  function mountFishingForm(root, cfg, product, productTitle) {
    var designs  = (product && product.designs)  || [];
    var images   = (product && product.images)   || [];
    var variantImageMap = (product && product.variantImageMap) || {};
    var selDesign = designs.length > 0 ? designs[0] : '';
    var selGarment = 'afs';
    var selSleeve = 'Long Sleeve';
    var sizeValues = {};
    var SLEEVE_TYPES = cfg.sleeve_types && cfg.sleeve_types.length ? cfg.sleeve_types : ['Long Sleeve', 'Short Sleeve', 'Singlet', 'Tank Top'];

    function render() {
      var sizes = SIZES[selGarment] || [];
      var tiers = getTiers(cfg, selGarment);
      var formUnits = Object.values(sizeValues).reduce(function(s, v) { return s + (v || 0); }, 0);
      var allUnits = totalUnits() + formUnits;

      var html = '<div class="lif-root"><div class="lif-wrap">' + renderLeft(cfg) + '<div class="lif-right">';

      // Design
      if (designs.length > 1) {
        html += '<div class="lif-step"><p class="lif-section-label">Step 1 &mdash; Select your design</p>';
        html += '<div class="lif-select-wrap"><select class="lif-select" id="lif-design-sel"><option value="">Select a design &#9662;</option>';
        designs.forEach(function(d) { html += '<option value="' + d + '"' + (selDesign===d?' selected':'') + '>' + d + '</option>'; });
        html += '</select></div></div>';
      }

      // Sleeve type
      var stepNum = designs.length > 1 ? 2 : 1;
      html += '<div class="lif-step"><p class="lif-section-label">Step ' + stepNum + ' &mdash; Select sleeve type</p>';
      html += '<div class="lif-colour-card"><div class="lif-colour-pills">';
      SLEEVE_TYPES.forEach(function(sl) {
        html += '<button class="lif-colour-pill' + (selSleeve===sl?' active':'') + '" data-sleeve="' + sl + '" type="button">' + sl + '</button>';
      });
      html += '</div></div></div>';

      // Garment + sizes
      html += '<div class="lif-step"><p class="lif-section-label">Step ' + (stepNum+1) + ' &mdash; Select garment &amp; enter quantities</p>';
      html += '<div class="lif-garment-card">';
      html += '<div class="lif-garment-tabs">';
      html += '<button class="lif-garment-tab' + (selGarment==='afs'?' active':'') + '" data-garment="afs" type="button">Adult shirts</button>';
      if (cfg.show_kids_tee !== false) {
        html += '<button class="lif-garment-tab' + (selGarment==='kfs'?' active':'') + '" data-garment="kfs" type="button">Kids shirts</button>';
      }
      html += '</div>';
      if (selGarment === 'afs' && cfg.afs_info) html += '<div class="lif-garment-info">' + cfg.afs_info + '</div>';
      if (selGarment === 'kfs' && cfg.kfs_info) html += '<div class="lif-garment-info">' + cfg.kfs_info + '</div>';

      html += '<div class="lif-size-rows">';
      sizes.forEach(function(size) {
        var safeId = size.replace('/', '');
        html += '<div class="lif-size-row">';
        html += '<span class="lif-size-label">' + size + '</span>';
        html += '<span class="lif-size-price" id="lif-size-price-' + safeId + '">-</span>';
        html += '<div class="lif-size-stepper">';
        html += '<button class="lif-stepper-btn" data-size="' + size + '" data-delta="-1" type="button">&#8722;</button>';
        html += '<input class="lif-stepper-input" type="number" min="0" value="' + (sizeValues[size]||'') + '" placeholder="0" data-size="' + size + '">';
        html += '<button class="lif-stepper-btn" data-size="' + size + '" data-delta="1" type="button">+</button>';
        html += '</div></div>';
      });
      html += '</div>';

      html += '<button class="lif-add-combo-btn" id="lif-add-combo" type="button">+ Add this combination to order</button>';
      html += '<div class="lif-msg" id="lif-msg"></div>';
      html += renderTierBar(tiers, allUnits, '');
      html += '</div></div></div></div></div>';

      root.innerHTML = html;

      // Events
      var dSel = el('lif-design-sel');
      if (dSel) dSel.addEventListener('change', function() { selDesign = this.value; galleryActiveDesign = selDesign; refreshGalleryThumbs(); var img = findImage(images, selDesign, null, variantImageMap); if(img) setPreview(img.src, img.alt); render(); });

      root.querySelectorAll('[data-sleeve]').forEach(function(btn) { btn.addEventListener('click', function() { selSleeve = btn.dataset.sleeve; render(); }); });
      root.querySelectorAll('.lif-garment-tab').forEach(function(tab) { tab.addEventListener('click', function() { selGarment = tab.dataset.garment; sizeValues = {}; render(); }); });
      root.querySelectorAll('.lif-stepper-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var size = btn.dataset.size;
          sizeValues[size] = Math.max(0, (sizeValues[size]||0) + parseInt(btn.dataset.delta,10));
          var inp = root.querySelector('[data-size="'+size+'"].lif-stepper-input'); if(inp) inp.value = sizeValues[size]||'';
          recalcFishing(tiers);
        });
      });
      root.querySelectorAll('.lif-stepper-input').forEach(function(inp) {
        inp.addEventListener('input', function() { var v=parseInt(inp.value,10); sizeValues[inp.dataset.size]=isNaN(v)?0:Math.max(0,v); recalcFishing(tiers); });
      });
      var addBtn = el('lif-add-combo');
      if (addBtn) addBtn.addEventListener('click', function() {
        var msgEl = el('lif-msg');
        if (designs.length>1 && !selDesign) { showMsg(msgEl,'error','Please select a design.'); return; }
        var sizesFiltered = {}; var formUnits2=0;
        Object.keys(sizeValues).forEach(function(s){if(sizeValues[s]>0){sizesFiltered[s]=sizeValues[s];formUnits2+=sizeValues[s];}});
        if (!formUnits2) { showMsg(msgEl,'error','Enter at least 1 unit.'); return; }
        var tiers2 = getTiers(cfg, selGarment);
        var allUnits2 = totalUnits()+formUnits2;
        var unitPrice2 = getTierPrice(tiers2, allUnits2);
        var lineTotal2 = formUnits2 * unitPrice2;
        orderLines.push({ id:++lineIdCounter, design:selDesign, garmentType:selGarment, garmentLabel:selGarment==='afs'?'Adult':'Kids', sleeveType:selSleeve, sizes:sizesFiltered, units:formUnits2, unitPrice:unitPrice2, tier:getTierLabel(tiers2,allUnits2), lineTotal:lineTotal2, printMethod:'Fishing Shirt' });
        sizeValues={};
        showMsg(msgEl,'success','Added!'); setTimeout(function(){if(msgEl)msgEl.className='lif-msg';},2500);
        updateSummary(cfg,'fishing-shirt',{onRemove:function(){render();}});
        attachSubmit(root,cfg,'fishing-shirt');
        recalcFishing(getTiers(cfg,selGarment));
      });

      if (selDesign) { var img=findImage(images, selDesign, null, variantImageMap); if(img) setPreview(img.src,img.alt); }
      else if (images.length) { setPreview(images[0].src, images[0].alt); }
      bindGalleryThumbs();
      recalcFishing(tiers);
      updateSummary(cfg,'fishing-shirt',{onRemove:function(){render();}});
      attachSubmit(root,cfg,'fishing-shirt');

      function recalcFishing(tiers) {
        var formUnits2=Object.values(sizeValues).reduce(function(s,v){return s+(v||0);},0);
        var allUnits2=totalUnits()+formUnits2;
        var unitPrice2=getTierPrice(tiers,allUnits2);
        (SIZES[selGarment]||[]).forEach(function(size){var pe=el('lif-size-price-'+size.replace('/',''));if(pe)pe.textContent=unitPrice2>0?fmt(unitPrice2)+' each (from)':'-';});
        var tm=el('lif-tier-msg');if(tm)tm.textContent=formUnits2>0?'Current: '+fmt(unitPrice2)+'/unit · '+getTierLabel(tiers,allUnits2):'Add combinations to see your live pricing.';
      }
    }

    render();
    // Show first image on load if no design selected
    if (!selDesign && images.length) setPreview(images[0].src, images[0].alt || '');
    bindGalleryThumbs();
  }

  // ══════════════════════════════════════════════════════════════════════════
  // FOOTY SHORTS — same pattern as fishing
  // ══════════════════════════════════════════════════════════════════════════
  function mountFootyForm(root, cfg, product, productTitle) {
    var designs = (product && product.designs) || [];
    var images  = (product && product.images)  || [];
    var variantImageMap = (product && product.variantImageMap) || {};
    var selDesign  = designs.length === 1 ? designs[0] : '';
    var selGarment = 'ashort';
    var sizeValues = {};
    var POCKET_TYPES = cfg.pocket_types && cfg.pocket_types.length ? cfg.pocket_types : ['No Pocket','Side Pocket','Back Pocket','Zippered Pocket'];
    var selPocket  = 'No Pocket';

    function render() {
      var sizes = SIZES[selGarment] || [];
      var tiers = getTiers(cfg, selGarment);
      var formUnits = Object.values(sizeValues).reduce(function(s,v){return s+(v||0);},0);
      var allUnits = totalUnits()+formUnits;

      var html = '<div class="lif-root"><div class="lif-wrap">'+renderLeft(cfg)+'<div class="lif-right">';

      if (designs.length > 1) {
        html += '<div class="lif-step"><p class="lif-section-label">Step 1 &mdash; Select your design</p>';
        html += '<div class="lif-select-wrap"><select class="lif-select" id="lif-design-sel"><option value="">Select a design &#9662;</option>';
        designs.forEach(function(d){html+='<option value="'+d+'"'+(selDesign===d?' selected':'')+'>'+d+'</option>';});
        html += '</select></div></div>';
      }

      var stepNum = designs.length > 1 ? 2 : 1;
      html += '<div class="lif-step"><p class="lif-section-label">Step '+stepNum+' &mdash; Pocket type</p>';
      html += '<div class="lif-colour-card"><div class="lif-colour-pills">';
      POCKET_TYPES.forEach(function(pt){html+='<button class="lif-colour-pill'+(selPocket===pt?' active':'')+'" data-pocket="'+pt+'" type="button">'+pt+'</button>';});
      html += '</div></div></div>';

      html += '<div class="lif-step"><p class="lif-section-label">Step '+(stepNum+1)+' &mdash; Select garment &amp; enter quantities</p>';
      html += '<div class="lif-garment-card">';
      html += '<div class="lif-garment-tabs">';
      html += '<button class="lif-garment-tab'+(selGarment==='ashort'?' active':'')+'" data-garment="ashort" type="button">Adult shorts</button>';
      if (cfg.show_kids_tee !== false) html += '<button class="lif-garment-tab'+(selGarment==='kshort'?' active':'')+'" data-garment="kshort" type="button">Kids shorts</button>';
      html += '</div>';

      html += '<div class="lif-size-rows">';
      sizes.forEach(function(size){
        var safeId=size.replace('/','');
        html+='<div class="lif-size-row"><span class="lif-size-label">'+size+'</span><span class="lif-size-price" id="lif-size-price-'+safeId+'">-</span>';
        html+='<div class="lif-size-stepper"><button class="lif-stepper-btn" data-size="'+size+'" data-delta="-1" type="button">&#8722;</button>';
        html+='<input class="lif-stepper-input" type="number" min="0" value="'+(sizeValues[size]||'')+'" placeholder="0" data-size="'+size+'">';
        html+='<button class="lif-stepper-btn" data-size="'+size+'" data-delta="1" type="button">+</button></div></div>';
      });
      html += '</div>';
      html += '<button class="lif-add-combo-btn" id="lif-add-combo" type="button">+ Add this combination to order</button>';
      html += '<div class="lif-msg" id="lif-msg"></div>';
      html += renderTierBar(tiers, allUnits, '');
      html += '</div></div></div></div></div>';

      root.innerHTML = html;

      var dSel=el('lif-design-sel');
      if(dSel) dSel.addEventListener('change',function(){selDesign=this.value;var img=findImage(images, selDesign, null, variantImageMap);if(img)setPreview(img.src,img.alt);render();});
      root.querySelectorAll('[data-pocket]').forEach(function(btn){btn.addEventListener('click',function(){selPocket=btn.dataset.pocket;render();});});
      root.querySelectorAll('.lif-garment-tab').forEach(function(tab){tab.addEventListener('click',function(){selGarment=tab.dataset.garment;sizeValues={};render();});});
      root.querySelectorAll('.lif-stepper-btn').forEach(function(btn){
        btn.addEventListener('click',function(){var size=btn.dataset.size;sizeValues[size]=Math.max(0,(sizeValues[size]||0)+parseInt(btn.dataset.delta,10));var inp=root.querySelector('[data-size="'+size+'"].lif-stepper-input');if(inp)inp.value=sizeValues[size]||'';recalcFooty(tiers);});
      });
      root.querySelectorAll('.lif-stepper-input').forEach(function(inp){inp.addEventListener('input',function(){var v=parseInt(inp.value,10);sizeValues[inp.dataset.size]=isNaN(v)?0:Math.max(0,v);recalcFooty(tiers);});});
      var addBtn=el('lif-add-combo');
      if(addBtn) addBtn.addEventListener('click',function(){
        var msgEl=el('lif-msg');
        if(designs.length>1&&!selDesign){showMsg(msgEl,'error','Please select a design.');return;}
        var sf={};var fu=0;Object.keys(sizeValues).forEach(function(s){if(sizeValues[s]>0){sf[s]=sizeValues[s];fu+=sizeValues[s];}});
        if(!fu){showMsg(msgEl,'error','Enter at least 1 unit.');return;}
        var t2=getTiers(cfg,selGarment);var au2=totalUnits()+fu;var up2=getTierPrice(t2,au2);
        var pocketSurch2=(selPocket==='Zippered Pocket')?(cfg.pocket_zip_surcharge||2.00):0;
        orderLines.push({id:++lineIdCounter,design:selDesign,garmentType:selGarment,garmentLabel:selGarment==='ashort'?'Adult':'Kids',pocketType:selPocket,sizes:sf,units:fu,unitPrice:up2,pocketSurcharge:pocketSurch2,tier:getTierLabel(t2,au2),lineTotal:fu*(up2+pocketSurch2),printMethod:'Footy Shorts'});
        sizeValues={};showMsg(msgEl,'success','Added!');setTimeout(function(){if(msgEl)msgEl.className='lif-msg';},2500);
        updateSummary(cfg,'footy-shorts',{onRemove:function(){render();}});attachSubmit(root,cfg,'footy-shorts');recalcFooty(getTiers(cfg,selGarment));
      });

      if(selDesign){var img=findImage(images, selDesign, null, variantImageMap);if(img)setPreview(img.src,img.alt);}
      recalcFooty(tiers);
      updateSummary(cfg,'footy-shorts',{onRemove:function(){render();}});
      attachSubmit(root,cfg,'footy-shorts');

      function recalcFooty(tiers){
        var fu=Object.values(sizeValues).reduce(function(s,v){return s+(v||0);},0);
        var au=totalUnits()+fu;var up=getTierPrice(tiers,au);
        var pocketSurch=(selPocket==='Zippered Pocket')?(cfg.pocket_zip_surcharge||2.00):0;
        (SIZES[selGarment]||[]).forEach(function(size){var pe=el('lif-size-price-'+size.replace('/',''));if(pe)pe.textContent=up>0?fmt(up+pocketSurch)+' each'+(pocketSurch?' (incl. pocket surcharge)':''):'-';});
        var tm=el('lif-tier-msg');if(tm)tm.textContent=fu>0?'Current: '+fmt(up+pocketSurch)+'/unit · '+getTierLabel(tiers,au)+(pocketSurch?' (incl. $'+pocketSurch.toFixed(2)+' zippered pocket)':''):'Add combinations to see your live pricing.';
      }
    }
    render();
  }

  // ══════════════════════════════════════════════════════════════════════════
  // COOLERS FORM
  // ══════════════════════════════════════════════════════════════════════════
  function mountCoolersForm(root, cfg, product, productTitle) {
    var designs  = (product && product.designs) || [];
    var images   = (product && product.images)  || [];
    var variantImageMap = (product && product.variantImageMap) || {};
    var PACKS = [
      { qty: 60,  price: 372.00 },
      { qty: 110, price: 577.50 },
      { qty: 200, price: 920.00 },
      { qty: 500, price: 2125.00 },
    ];
    var selDesign = designs.length > 0 ? designs[0] : '';
    var selPack = null;

    function render() {
      var html = '<div class="lif-root"><div class="lif-wrap">'+renderLeft(cfg)+'<div class="lif-right">';

      if (designs.length > 1) {
        html += '<div class="lif-step"><p class="lif-section-label">Step 1 &mdash; Select your design</p>';
        html += '<div class="lif-select-wrap"><select class="lif-select" id="lif-design-sel"><option value="">Select a design &#9662;</option>';
        designs.forEach(function(d){html+='<option value="'+d+'"'+(selDesign===d?' selected':'')+'>'+d+'</option>';});
        html += '</select></div></div>';
      }

      var stepNum = designs.length > 1 ? 2 : 1;
      html += '<div class="lif-step"><p class="lif-section-label">Step '+stepNum+' &mdash; Select pack size</p>';
      html += '<div class="lif-pack-grid">';
      PACKS.forEach(function(pack){
        var isActive = selPack && selPack.qty === pack.qty;
        html += '<button class="lif-pack-card'+(isActive?' active':'')+'" data-qty="'+pack.qty+'" data-price="'+pack.price+'" type="button">';
        html += '<span class="lif-pack-qty">'+pack.qty+' pack</span>';
        html += '<span class="lif-pack-price">'+fmt(pack.price)+'</span>';
        html += '<span class="lif-pack-unit">'+fmt(pack.price/pack.qty)+'/unit</span>';
        html += '</button>';
      });
      html += '</div></div>';

      html += '<button class="lif-add-combo-btn" id="lif-add-combo" type="button">+ Add to order</button>';
      html += '<div class="lif-msg" id="lif-msg"></div>';
      html += '</div></div></div>';

      root.innerHTML = html;

      var dSel=el('lif-design-sel');
      if(dSel) dSel.addEventListener('change',function(){selDesign=this.value;var img=findImage(images, selDesign, null, variantImageMap);if(img)setPreview(img.src,img.alt);render();});

      root.querySelectorAll('.lif-pack-card').forEach(function(card){
        card.addEventListener('click',function(){selPack={qty:parseInt(card.dataset.qty,10),price:parseFloat(card.dataset.price)};render();});
      });

      var addBtn=el('lif-add-combo');
      if(addBtn) addBtn.addEventListener('click',function(){
        var msgEl=el('lif-msg');
        if(designs.length>1&&!selDesign){showMsg(msgEl,'error','Please select a design.');return;}
        if(!selPack){showMsg(msgEl,'error','Please select a pack size.');return;}
        orderLines.push({id:++lineIdCounter,design:selDesign,qty:selPack.qty,units:selPack.qty,unitPrice:+(selPack.price/selPack.qty).toFixed(2),lineTotal:selPack.price,printMethod:'Can Cooler',label:selDesign+(selDesign?' — ':'')+selPack.qty+' pack'});
        selPack=null;showMsg(msgEl,'success','Added!');setTimeout(function(){if(msgEl)msgEl.className='lif-msg';},2500);
        updateSummary(cfg,'coolers',{onRemove:function(){render();}});attachSubmit(root,cfg,'coolers');
      });

      if(selDesign){var img=findImage(images, selDesign, null, variantImageMap);if(img)setPreview(img.src,img.alt);}
      updateSummary(cfg,'coolers',{onRemove:function(){render();}});
      attachSubmit(root,cfg,'coolers');
    }
    render();
  }

  // ══════════════════════════════════════════════════════════════════════════
  // CAPS FORM
  // ══════════════════════════════════════════════════════════════════════════
  function mountCapsForm(root, cfg, product, productTitle) {
    var variants = (product && product.variants) || [];
    var images   = (product && product.images)  || [];
    var hexMap   = (product && product.colourHexMap) || {};
    var selVariant = null;
    var qty = '';

    function render() {
      var html = '<div class="lif-root"><div class="lif-wrap">'+renderLeft(cfg)+'<div class="lif-right">';
      html += '<div class="lif-step"><p class="lif-section-label">Select colourway</p>';
      html += '<div class="lif-colour-pills">';
      variants.forEach(function(v){
        var hex = getSwatchColour(v.option1, hexMap);
        html += '<button class="lif-colour-pill'+(selVariant&&selVariant.id===v.id?' active':'')+'" data-varid="'+v.id+'" data-label="'+v.option1+'" type="button">';
        html += '<span class="lif-colour-dot" style="background:'+hex+';"></span>'+v.option1;
        html += '</button>';
      });
      html += '</div></div>';

      html += '<div class="lif-step"><p class="lif-section-label">Quantity (min ' + (cfg.minimum_order || 12) + ')</p>';
      html += '<input class="lif-qty-input" id="lif-qty" type="number" min="'+(cfg.minimum_order||12)+'" placeholder="'+(cfg.minimum_order||12)+'" value="'+(qty||'')+'">';
      html += '<p style="font-size:12px;color:#555;margin-top:8px;">Pricing is set per colourway in Shopify. The draft order will show the correct unit price.</p>';
      html += '</div>';

      html += '<button class="lif-add-combo-btn" id="lif-add-combo" type="button">+ Add to order</button>';
      html += '<div class="lif-msg" id="lif-msg"></div>';
      html += '</div></div></div>';

      root.innerHTML = html;

      root.querySelectorAll('[data-varid]').forEach(function(btn){
        btn.addEventListener('click',function(){
          selVariant = variants.find(function(v){return v.id===btn.dataset.varid;});
          var img = images.find(function(i){return (i.alt||'').toLowerCase()===btn.dataset.label.toLowerCase();})||images[0];
          if(img) setPreview(img.src,img.alt);
          render();
        });
      });

      var qtyInp=el('lif-qty');
      if(qtyInp) qtyInp.addEventListener('input',function(){qty=this.value;});

      var addBtn=el('lif-add-combo');
      if(addBtn) addBtn.addEventListener('click',function(){
        var msgEl=el('lif-msg');
        if(!selVariant){showMsg(msgEl,'error','Please select a colourway.');return;}
        var q=parseInt(qty,10);
        if(!q||q<(cfg.minimum_order||12)){showMsg(msgEl,'error','Minimum '+(cfg.minimum_order||12)+' units.');return;}
        orderLines.push({id:++lineIdCounter,design:selVariant.option1,units:q,qty:q,unitPrice:0,lineTotal:0,variantId:selVariant.id,printMethod:'Caps',label:selVariant.option1+' × '+q});
        qty='';showMsg(msgEl,'success','Added!');setTimeout(function(){if(msgEl)msgEl.className='lif-msg';},2500);
        updateSummary(cfg,'caps',{onRemove:function(){render();}});attachSubmit(root,cfg,'caps');
      });

      updateSummary(cfg,'caps',{onRemove:function(){render();}});
      attachSubmit(root,cfg,'caps');
    }
    render();
  }

  // ══════════════════════════════════════════════════════════════════════════
  // ACCESSORIES FORM (bar mat, beanie, bucket hat, straw hat, stickers, etc)
  // ══════════════════════════════════════════════════════════════════════════
  function mountAccessoriesForm(root, cfg, product, productTitle) {
    var designs  = (product && product.designs)  || [];
    var variants = (product && product.variants) || [];
    var images   = (product && product.images)   || [];
    var variantImageMap = (product && product.variantImageMap) || {};
    var selDesign  = designs.length === 1 ? designs[0] : '';
    var selVariant = variants.length === 1 ? variants[0] : null;
    var qty = '';

    function render() {
      var html = '<div class="lif-root"><div class="lif-wrap">'+renderLeft(cfg)+'<div class="lif-right">';

      if (designs.length > 1) {
        html += '<div class="lif-step"><p class="lif-section-label">Select design</p>';
        html += '<div class="lif-select-wrap"><select class="lif-select" id="lif-design-sel"><option value="">Select a design &#9662;</option>';
        designs.forEach(function(d){html+='<option value="'+d+'"'+(selDesign===d?' selected':'')+'>'+d+'</option>';});
        html += '</select></div></div>';
      }

      if (variants.length > 1 && designs.length === 0) {
        html += '<div class="lif-step"><p class="lif-section-label">Select option</p>';
        html += '<div class="lif-colour-pills">';
        variants.forEach(function(v){html+='<button class="lif-colour-pill'+(selVariant&&selVariant.id===v.id?' active':'')+'" data-varid="'+v.id+'" data-label="'+v.option1+'" type="button">'+v.option1+'</button>';});
        html += '</div></div>';
      }

      var minLabel = cfg.minimum_order > 1 ? ' (min ' + (cfg.minimum_order || 1) + ')' : '';
      html += '<div class="lif-step"><p class="lif-section-label">Quantity' + minLabel + '</p>';
      html += '<input class="lif-qty-input" id="lif-qty" type="number" min="'+(cfg.minimum_order||1)+'" placeholder="'+(cfg.minimum_order||1)+'" value="'+(qty||'')+'">';
      html += '</div>';

      html += '<button class="lif-add-combo-btn" id="lif-add-combo" type="button">+ Add to order</button>';
      html += '<div class="lif-msg" id="lif-msg"></div>';
      html += '</div></div></div>';

      root.innerHTML = html;

      var dSel=el('lif-design-sel');
      if(dSel) dSel.addEventListener('change',function(){selDesign=this.value;var img=findImage(images, selDesign, null, variantImageMap);if(img)setPreview(img.src,img.alt);render();});

      root.querySelectorAll('[data-varid]').forEach(function(btn){
        btn.addEventListener('click',function(){selVariant=variants.find(function(v){return v.id===btn.dataset.varid;});render();});
      });

      var qtyInp=el('lif-qty');
      if(qtyInp) qtyInp.addEventListener('input',function(){qty=this.value;});

      var addBtn=el('lif-add-combo');
      if(addBtn) addBtn.addEventListener('click',function(){
        var msgEl=el('lif-msg');
        var q=parseInt(qty,10);
        if(!q||q<(cfg.minimum_order||1)){showMsg(msgEl,'error','Minimum '+(cfg.minimum_order||1)+' units.');return;}
        orderLines.push({id:++lineIdCounter,design:selDesign||null,units:q,qty:q,unitPrice:0,lineTotal:0,variantId:selVariant?selVariant.id:null,printMethod:cfg.form_type||'Accessories',label:(selDesign||'Item')+' × '+q});
        qty='';showMsg(msgEl,'success','Added!');setTimeout(function(){if(msgEl)msgEl.className='lif-msg';},2500);
        updateSummary(cfg,cfg.form_type||'accessories',{onRemove:function(){render();}});attachSubmit(root,cfg,cfg.form_type||'accessories');
      });

      if(selDesign){var img=findImage(images, selDesign, null, variantImageMap);if(img)setPreview(img.src,img.alt);}
      updateSummary(cfg,cfg.form_type||'accessories',{onRemove:function(){render();}});
      attachSubmit(root,cfg,cfg.form_type||'accessories');
    }
    render();
  }

  // ── Shared: show msg ──────────────────────────────────────────────────────
  function showMsg(el, type, text) {
    if (!el) return;
    el.className = 'lif-msg ' + type;
    el.textContent = text;
  }

  // ── Boot ──────────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();